<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CustomerList',
})
</script>
<template>
    <a-card :bordered="false">
        <div class="table-page-search-wrapper">
            <a-form>
                <a-row :gutter="48">
                    <a-col :md="6" :sm="24">
                        <a-form-item label="平台名称" name="platform_id">
                            <PlatformPick @keyup.enter.native="loadData" v-model:value="queryParam.platform_id">
                            </PlatformPick>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="公司名称" name="nameOrCode">
                            <a-input @keyup.enter="loadData" @change="
                                (v) => {
                                    nameOrCodeChange()
                                }
                            " v-model:value="queryParam.nameOrCode" placeholder="请输入公司名称、税号" @click="
                                () => {
                                    if (data.tabsKey == 1 || data.tabsKey == 3) {
                                        data.tabsKey = data.tabsKey + 1
                                        queryParam.order_status_list = []
                                    }
                                }
                            ">
                            </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="地址编号" name="address_number">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.address_number"
                                placeholder="请输入"> </a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="续费号码或微信昵称" name="xftel">
                            <a-input @keyup.enter="loadData" v-model:value="queryParam.xftel" placeholder="请输入">
                            </a-input>
                        </a-form-item>
                    </a-col>
                    <template v-if="data.advanced">
                        <a-col :md="6" :sm="24">
                            <a-form-item label="入驻类型" name="business_type">
                                <a-select allow-clear @keyup.enter.native="loadData" mode="multiple"
                                    v-model:value="queryParam.business_type" placeholder="请选择">
                                    <a-select-option :value="1">设立</a-select-option>
                                    <a-select-option :value="2">同区迁入</a-select-option>
                                    <a-select-option :value="3">跨区迁入</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="主体类型" name="main_type">
                                <a-select allow-clear @keyup.enter.native="loadData" mode="multiple"
                                    v-model:value="queryParam.main_type" placeholder="请选择">
                                    <a-select-option :value="1">公司</a-select-option>
                                    <a-select-option :value="2">个体</a-select-option>
                                    <a-select-option :value="3">个人独资</a-select-option>
                                    <a-select-option :value="4">合伙企业</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="法代姓名" name="fr_name">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.fr_name" placeholder="请输入">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24" v-hasRole="['root']">
                            <a-form-item label="代理商或录单人姓名" name="seller">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.seller" placeholder="请输入">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="付款状态" name="is_pay">
                                <a-select allow-clear @keyup.enter.native="loadData" mode="multiple"
                                    v-model:value="queryParam.is_pay" placeholder="请选择">
                                    <a-select-option :value="1">已付款</a-select-option>
                                    <a-select-option :value="2">未付款</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="收费类型" name="fee_standard">
                                <a-select allow-clear @keyup.enter.native="loadData" mode="multiple"
                                    v-model:value="queryParam.fee_standard" placeholder="请选择">
                                    <a-select-option :value="1">按年收费</a-select-option>
                                    <a-select-option :value="2">一次性</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="主体状态" name="exception_flag">
                                <a-select allow-clear @keyup.enter.native="loadData" mode="multiple"
                                    v-model:value="queryParam.exception_flag" placeholder="请选择">
                                    <a-select-option :value="1">正常状态</a-select-option>
                                    <a-select-option :value="2">待申报异常【代理商待确认①】</a-select-option>
                                    <a-select-option :value="3">待申报异常【代理商已确认，公司待确认②】</a-select-option>
                                    <a-select-option :value="4">待申报异常【代理商、公司已确认，准备提交资料③】</a-select-option>
                                    <a-select-option :value="5">已申报异常【已交资料，待确认是否地址异常】</a-select-option>
                                    <a-select-option :value="6">人工已确认地址已异常</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="录单时间" name="between_time">
                                <a-range-picker @keyup.enter.native="loadData"
                                    :show-time="{ defaultValue: arrayMonent }" :value="rangTime"
                                    @change="rangTimeChange" :format="format"></a-range-picker>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24" v-if="(data.user_permission = 'admin')">
                            <a-form-item label="工商更新时间大于" name="tyc_update_time_gt">
                                <a-date-picker @keyup.enter.native="loadData" show-time placeholder="工商更新时间大于>"
                                    v-model:value="queryParam.tyc_update_time_gt" />
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24" v-if="(data.user_permission = 'admin')">
                            <a-form-item label="工商更新时间小于" name="tyc_update_time_lt">
                                <a-date-picker @keyup.enter.native="loadData" show-time placeholder="工商更新时间小于<"
                                    v-model:value="queryParam.tyc_update_time_lt" />
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="主体税务状态" name="tax_status">
                                <a-select allow-clear @keyup.enter.native="loadData" mode="multiple"
                                    v-model:value="queryParam.tax_status" placeholder="请选择">
                                    <a-select-option :value="1">正常状态</a-select-option>
                                    <a-select-option :value="2">注销</a-select-option>
                                    <a-select-option :value="3">清算</a-select-option>
                                    <a-select-option :value="4">非正常</a-select-option>
                                    <a-select-option :value="5">未办理税务登记</a-select-option>
                                    <a-select-option :value="6">未知</a-select-option>
                                    <a-select-option :value="7">未得到状态</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24" v-if="(data.user_permission = 'admin')">
                            <a-form-item label="税务更新时间大于" name="tax_check_time_gt">
                                <a-date-picker @keyup.enter.native="loadData" show-time placeholder="税务更新时间大于>"
                                    v-model:value="queryParam.tax_check_time_gt" />
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24" v-if="(data.user_permission = 'admin')">
                            <a-form-item label="税务更新时间小于" name="tax_check_time_lt">
                                <a-date-picker @keyup.enter.native="loadData" show-time placeholder="税务更新时间小于<"
                                    v-model:value="queryParam.tax_check_time_lt" />
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="经营范围包含" name="business_scope_like">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.business_scope_like"
                                    placeholder="请输入，多个用#隔开">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="经营范围排除" name="business_scope_notlike">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.business_scope_notlike"
                                    placeholder="请输入，多个用#隔开">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="通用备注" name="common_remark">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.common_remark"
                                    placeholder="平台管理员可以看到的通用备注">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="税务身份" name="is_ybr">
                                <a-select allow-clear @keyup.enter.native="loadData" mode="multiple"
                                    v-model:value="queryParam.is_ybr" placeholder="请选择">
                                    <a-select-option :value="1">一般纳税人</a-select-option>
                                    <a-select-option :value="2">小规模纳税人</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="包含Tags" name="tags">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.tags"
                                    placeholder="请输入tags，多个用#隔开">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="对接人" name="platform_wechat_account">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.platform_wechat_account"
                                    placeholder="">
                                </a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :md="6" :sm="24">
                            <a-form-item label="身份证住址" name="address">
                                <a-input @keyup.enter="loadData" v-model:value="queryParam.address">
                                </a-input>
                            </a-form-item>
                        </a-col>
                    </template>
                    <a-col :md="7" :sm="24">
                        <div class="navlist">
                            <a-button type="primary" :icon="h(PlusOutlined)" @click="handleAdd">新增客户</a-button>
                            <a-button type="primary" @click="onActionClick({}, 'SignatureStatus')"
                                :icon="h(SearchOutlined)" v-hasRole="['root']">查询签名</a-button>
                            <a-button type="primary" danger :icon="h(PlusOutlined)" @click="gototencentword"
                                v-hasRole="['root', 'ludan']">教程</a-button>
                        </div>
                    </a-col>
                    <a-col :md="5" :sm="24">
                        <a-form-item label="包含已删除主体" name="recycle">
                            <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="是" un-checked-children="否"
                                v-model:checked="queryParam.recycle"></a-switch>
                            <a-divider type="vertical" />
                            <a-switch :checkedValue="1" :unCheckedValue="2" checked-children="简版开启"
                                un-checked-children="简版关闭" v-model:checked="data.list_simple"></a-switch>
                            <div style="padding-left: 10px; float: right; padding-top: 5px"
                                v-if="data.user_permission != 'shixi'">
                                <a-badge color="#1677ff" class="pointer" @click="showWXInform"
                                    :count="data.customerNavig.customer_chat_count" :offset="[5, -5]">
                                    <span class="action ant-dropdown-link user-dropdown-menu">
                                        <WechatOutlined style="font-size: 20px" />
                                    </span>
                                </a-badge>
                            </div>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-form-item label="进度状态" name="order_status">
                            <a-select allow-clear @keyup.enter.native="loadData" mode="multiple"
                                :disabled="queryParam.order_status" v-model:value="queryParam.order_status_list"
                                placeholder="请选择" @change="orderStatusChange" @select="orderStatusSelect"
                                @deselect="orderStatusDeselect" option-filter-prop="label">
                                <a-select-option v-for="(item, index) in data.progressOptions" :key="index"
                                    :label="item.text" :value="item.value">{{ item.text
                                    }}</a-select-option>
                            </a-select>
                        </a-form-item>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <div class="table-page-search-submitButtons" style="overflow: hidden; margin-bottom: 0">
                            <a-button type="primary" @click="loadData" :icon="h(SearchOutlined)">查询</a-button>
                            <a @click="toggleAdvanced" style="margin-left: 8px">
                                {{ data.advanced ? '收起' : '展开' }}
                                <UpOutlined v-if="data.advanced" />
                                <DownOutlined v-else />
                            </a>
                            <a-popover title="导出参数配置" trigger="click" :overlayStyle="{ width: '60%' }" placement="left"
                                v-model:open="exportDataArgumentChecked.visible">
                                <template #content>
                                    <a-tabs v-model:activeKey="exportDatatab">
                                        <a-tab-pane key="1" tab="根据搜索参数直接导出"><a-descriptions :column="1">
                                                <a-descriptions-item label="导出版本" :contentStyle="{ paddingTop: '10px' }"
                                                    :labelStyle="{ paddingTop: '10px' }">
                                                    <a-button
                                                        @click="selectExportDataArgument(1)">精简版</a-button><a-divider
                                                        type="vertical" /> <a-button
                                                        @click="selectExportDataArgument(2)">全能版</a-button><a-divider
                                                        type="vertical" />
                                                    <a-button @click="selectExportDataArgument(3)">取消选择</a-button>
                                                </a-descriptions-item>
                                                <a-descriptions-item label="导出字段">
                                                    <a-checkbox-group
                                                        v-model:value="exportDataArgumentChecked.checkedfieldSimple"
                                                        name="checkboxgroup"
                                                        :options="exportDataArgumentChecked.exportDataArgument" />
                                                </a-descriptions-item>
                                                <a-descriptions-item :contentStyle="{ paddingLeft: '62px' }">
                                                    <a-button style="margin-left: 8px; display: inline-flex"
                                                        :icon="h(SvgIcon, { name: 'excel' })" @click="exportClick(1)"
                                                        :loading="data.exportLoading_dc">导出</a-button>
                                                </a-descriptions-item>
                                            </a-descriptions></a-tab-pane>
                                        <a-tab-pane key="2" tab="根据输入的公司名称导出详细信息（选择此项，搜索条件将失效）"><a-descriptions
                                                :column="1">
                                                <a-descriptions-item label="公司名称" :contentStyle="{ paddingTop: '10px' }"
                                                    :labelStyle="{ paddingTop: '10px' }">
                                                    <a-textarea v-model:value="exportDataArgumentChecked.companylist"
                                                        placeholder="请输入公司名称" allow-clear :rows="6" />
                                                </a-descriptions-item>
                                                <a-descriptions-item label="导出版本" :contentStyle="{ paddingTop: '10px' }"
                                                    :labelStyle="{ paddingTop: '10px' }">
                                                    <a-button
                                                        @click="selectExportDataArgument(1)">精简版</a-button><a-divider
                                                        type="vertical" /> <a-button
                                                        @click="selectExportDataArgument(2)">全能版</a-button><a-divider
                                                        type="vertical" />
                                                    <a-button @click="selectExportDataArgument(3)">取消选择</a-button>
                                                </a-descriptions-item>
                                                <a-descriptions-item label="导出字段">
                                                    <a-checkbox-group
                                                        v-model:value="exportDataArgumentChecked.checkedfieldSimple"
                                                        name="checkboxgroup"
                                                        :options="exportDataArgumentChecked.exportDataArgument" />
                                                </a-descriptions-item>
                                                <a-descriptions-item :contentStyle="{ paddingLeft: '62px' }">
                                                    <a-button style="margin-left: 8px; display: inline-flex"
                                                        :icon="h(SvgIcon, { name: 'excel' })" @click="exportClick(2)"
                                                        :loading="data.exportLoading_dc">导出</a-button>
                                                </a-descriptions-item>
                                            </a-descriptions>
                                        </a-tab-pane>
                                    </a-tabs>
                                </template>
                                <a-button style="margin-left: 8px; display: inline-flex"
                                    :icon="h(SvgIcon, { name: 'excel' })" :loading="data.exportLoading_dc">导出</a-button>
                            </a-popover>
                            <a-popover title="更新" trigger="click" placement="left" v-model:open="data.tycupdateVisible"
                                v-if="user.id == 1">
                                <template #content>
                                    <div>您确定从天眼查更新数据吗？</div>
                                    <a-button @click="tycupdateData()" type="primary">立即更新</a-button>
                                </template>
                                <a-button style="margin-left: 8px; display: inline-flex"
                                    :icon="h(ThunderboltOutlined, { class: 'shandian' })"
                                    :loading="data.exportLoading_gx">更新</a-button>
                            </a-popover>
                        </div>
                    </a-col>
                    <a-col :md="6" :sm="24">
                        <a-popconfirm :title="`确定删除个${batchDelete.deleteIds.length}个客户吗?`" placement="left" @openChange="
                            (e) => {
                                openDeleteChangePage(e)
                            }
                        " @confirm="DeleteCustomerVisible()" v-if="data.advanced">
                            <template #description>
                                <a-form style="width: 600px" v-bind="formLayout">
                                    <a-form-item label="删除原因" required>
                                        <a-radio-group v-model:value="batchDelete.deleteType">
                                            <a-radio :value="1">废弃</a-radio>
                                        </a-radio-group>
                                    </a-form-item>
                                    <a-form-item label="理由" required v-if="batchDelete.deleteType == 1">
                                        <a-input v-model:value="batchDelete.desc" placeholder="请输入理由">
                                        </a-input>
                                    </a-form-item>
                                    <a-form-item label="备注"> 删除后可在主体回收站中撤回删除 </a-form-item>
                                </a-form>
                            </template>
                            <a-button type="primary" :loading="data.exportLoading_delete" :icon="h(DeleteOutlined)"
                                v-hasRole="['root', 'platform', 'shopmanager', 'seller']">批量删除本页客户</a-button>
                        </a-popconfirm><a-divider type="vertical" />
                        <a-popover title="更新纳税人状态" trigger="click" placement="left" v-model:open="data.taxupdateVisible"
                            v-if="user.id == 1">
                            <template #content>
                                <a-form-item label="更新类型"> <a-switch :checkedValue="1" :unCheckedValue="2"
                                        checked-children="更新所有" un-checked-children="仅更新无税务状态主体"
                                        v-model:checked="data.updatetype"></a-switch> </a-form-item>

                                <a-button @click="taxUpdateData()" type="primary">立即更新</a-button>
                            </template>
                            <a-button :icon="h(ThunderboltOutlined, { class: 'shandian' })">更新纳税人状态</a-button>
                        </a-popover>
                    </a-col>
                </a-row>
            </a-form>
        </div>
        <div class="tabs">
            <a-tabs v-model:activeKey="data.tabsKey" @change="tabsChange">
                <a-tab-pane :key="1" tab="我的办理中"> </a-tab-pane>
                <a-tab-pane :key="2" tab="我的所有客户"> </a-tab-pane>
                <a-tab-pane :key="3" tab="所有办理中" v-if="user.id == 1 || data.customerNavig.superPlatformAdminIds">
                </a-tab-pane>
                <a-tab-pane :key="4" tab="所有客户" v-if="user.id == 1 || data.customerNavig.superPlatformAdminIds">
                </a-tab-pane>
                <!-- <a-tab-pane :key="5" tab="参加活动的订单" v-if="user.id == 1 || data.customerNavig.superPlatformAdminIds"> </a-tab-pane> -->
                <a-tab-pane :key="6" tab="待申报地址异常"> </a-tab-pane>
            </a-tabs>
            <!-- 待申报异常子选项卡 -->
            <a-tabs v-model:activeKey="data.tabsExceptionKey" @change="tabsExceptionKeyChange" v-if="data.tabsKey == 6">
                <a-tab-pane :key="2" tab="待申报异常【代理商待确认①】"> </a-tab-pane>
                <a-tab-pane :key="3" tab="待申报异常【代理商已确认，公司待确认②】"> </a-tab-pane>
                <a-tab-pane :key="4" tab="待申报异常【代理商、公司已确认，准备提交资料③】"> </a-tab-pane>
                <a-tab-pane :key="5" tab="已申报异常【已交资料，待确认是否地址异常】"> </a-tab-pane>
                <a-tab-pane :key="6" tab="人工已确认地址已异常"> </a-tab-pane>
            </a-tabs>
            <div class="tabs" v-if="data.tabsKey == 6">
                <a-tabs v-model:activeKey="data.showtype" @change="loadtaizhang()">
                    <a-tab-pane :key="1" tab="待办事项" v-if="data.tabsExceptionKey == 2"> </a-tab-pane>
                    <a-tab-pane :key="1" tab="待办事项" v-if="data.tabsExceptionKey == 3"> </a-tab-pane>
                    <a-tab-pane :key="1" tab="待办事项" v-if="data.tabsExceptionKey == 4">
                    </a-tab-pane>
                    <a-tab-pane :key="1" tab="待办事项" v-if="data.tabsExceptionKey == 5"> </a-tab-pane>
                    <a-tab-pane :key="2" tab="台账（按时间排序）"> </a-tab-pane>
                </a-tabs>
                <a-button type="primary" :loading="data.download_sbException_loading" @click="downloadsbException"
                    v-if="[2, 3, 4, 5].includes(data.tabsExceptionKey) && data.showtype == 1"
                    style="position: absolute; top: 7px; left: 300px">导出待申报数据</a-button>
            </div>
            <!-- 待申报异常子选项卡end -->
            <div class="tabs-right" style="right: 600px" v-if="user.id == 1">
                <a-popover trigger="click" overlayClassName="customer-options-popover">
                    <template #content>
                        <a-popconfirm title="确定批量设置价格吗?" placement="left" @openChange="
                            (e) => {
                                openBatchPay(e)
                            }
                        " @confirm="handleBatchPay()">
                            <template #description>
                                <a-form style="width: 400px" v-bind="formLayout">
                                    <a-form-item label="批量设置价格（选填）" :labelCol="{ span: 10 }" :wrapperCol="{ span: 14 }">
                                        <a-input placeholder="批量设置价格（选填）" v-model:value="batchData.price"
                                            style="width: 150px" addonAfter="元"> </a-input>
                                    </a-form-item>
                                    <a-form-item label="备注"> 不填则按主体本身价格。 </a-form-item>
                                </a-form>
                            </template>
                            <p>分别充值后、再支付</p>
                        </a-popconfirm>
                        <a-popconfirm title="确定批量推送为已办结吗?" placement="left" @openChange="
                            (e) => {
                                openBatchBanjie(e)
                            }
                        " @confirm="handleBatchBanjie()">
                            <template #description>
                                <a-form style="width: 300px" v-bind="formLayout"> 一般用于长时间审核已通过后没有下文的主体，一般此种主体默认认为已办结。
                                </a-form>
                            </template>
                            <p>分别推送为已办结</p>
                        </a-popconfirm>
                        <p @click="handleBatchLicense()">一键下载全部营业执照</p>
                        <p>一键下载全部章程</p>

                        <a-popconfirm title="确定批量彻底物理删除客户吗？" v-if="user.id == 1" placement="left"
                            @confirm="batchHarddelete()">
                            <template #description>
                                <p>删除后无法找回，请非常谨慎的操作！！！</p>
                            </template>
                            <p>批量清除客户</p>
                        </a-popconfirm>
                        <a-popconfirm title="确定批量添加备注吗?" placement="left" @openChange="
                            (e) => {
                                openBatchRemark(e)
                            }
                        " @confirm="handleBatchRemark()">
                            <template #description>
                                <a-form style="width: 400px" v-bind="formLayout">
                                    <a-form-item label="备注" :labelCol="{ span: 5 }" :wrapperCol="{ span: 14 }">
                                        <a-input placeholder="追加备注" v-model:value="batchRemarkData.remark"> </a-input>
                                    </a-form-item>
                                </a-form>
                            </template>
                            <p>批量添加备注</p>
                        </a-popconfirm>
                        <ChangeExceptionflag :isBatch="true" :customerData="{ id: 0, exception_flag: 1 }"
                            :batchGetIds="handleBatchGetIds" @change="(exception_flag, endtime) => {
                                loadData()
                            }">
                            <p>批量调整异常状态</p>
                        </ChangeExceptionflag>
                    </template>
                    <p style="cursor: pointer">本页批量工具</p>
                </a-popover>
            </div>
            <div class="tabs-right" v-if="data.user_permission != 'shixi'">
                <div class="pointer" @click="onStisticsClick(1)">
                    <a-badge :count="data.customerNavig.unrecorded_electronic" :offset="[5, -5]">
                        <span :style="queryParam.order_status == 1 ? { color: 'var(--ant-primary-color)' } : {}"> 未录电子化
                        </span>
                    </a-badge>
                </div>
                <div class="pointer" @click="onStisticsClick(2)">
                    <a-badge :count="data.customerNavig.modify_data" :offset="[5, -5]">
                        <span :style="queryParam.order_status == 2 ? { color: 'var(--ant-primary-color)' } : {}"> 资料待修改
                        </span>
                    </a-badge>
                </div>
                <div class="pointer" @click="onStisticsClick(3)">
                    <a-badge :count="data.customerNavig.to_be_verified" :offset="[5, -5]"> 其他资料核验待审核 </a-badge>
                </div>
                <!-- <div class="pointer" @click="onStisticsClick(4)">
          <a-badge :count="data.customerNavig.filings" :offset="[5, -5]"> 渠道备案核验 </a-badge>
        </div> -->
                <div class="pointer" @click="onStisticsClick(5)">
                    <a-badge :count="data.customerNavig.unfinished_work_order" :offset="[5, -5]">
                        <span :style="queryParam.unsettled == 1 ? { color: 'var(--ant-primary-color)' } : {}"> 工单未办结
                        </span>
                    </a-badge>
                </div>
                <div class="pointer" @click="onStisticsClick(6)">
                    <a-badge :count="data.customerNavig.license_log_count" :offset="[5, -5]"> 营业执照归档 </a-badge>
                </div>

                <!-- <div class="pointer" @click="onStisticsClick(8)">
          <a-badge :count="data.customerNavig.download_agreement_count" :offset="[5, -5]"
            ><span :style="queryParam.downzc == 1 ? { color: 'var(--ant-primary-color)' } : {}"> 下载章程 </span>
          </a-badge>
        </div> -->
            </div>
        </div>
        <div v-if="data.showtype == 1">
            <a-table size="small" v-if="data.list_simple == 2" rowClassName="tableRowClass" :columns="columns"
                :loading="data.loading" :data-source="dataSource" :pagination="pagination" @change="onChange">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'companyInformation'">
                        <div class="companyInformation"
                            :style="record.exception_flag == 6 ? { borderLeft: '10px dashed #000' } : {}">
                            <a-tag color="grey" v-if="record.status === 2">该主体已注销</a-tag>
                            <a-tag color="grey" v-if="record.status === 3">该主体已吊销</a-tag>
                            <a-tag color="grey" v-if="record.status === 4">该主体已迁走</a-tag>
                            <a-popconfirm title="确定【撤销已迁走】?" @confirm="cancel_delete_zhuti(record.id, 4)">
                                <a v-if="record.status === 4">撤销已迁走</a>
                            </a-popconfirm>
                            <a-tag color="grey" v-if="record.status === 7">主体迁走审核中...</a-tag>
                            <a-popconfirm title="确定【撤销迁走审核】?" @confirm="cancel_delete_zhuti(record.id, 1)">
                                <a v-if="record.status === 7">撤销迁走审核</a>
                            </a-popconfirm>
                            <a-tag color="grey" v-if="record.status === 5">该主体已删除</a-tag>
                            <a-popconfirm title="确定【撤销已删除】?" @confirm="cancel_delete_zhuti(record.id, 3)">
                                <a v-if="record.status === 5">撤销已删除</a>
                            </a-popconfirm>
                            <a-tag v-if="record.status === 6" color="grey"> 主体删除审核中...</a-tag>
                            <a-popconfirm title="确定【撤销删除审核】?" @confirm="cancel_delete_zhuti(record.id, 2)">
                                <a v-if="record.status === 6">撤销删除审核</a>
                            </a-popconfirm>
                            <a-tag color="red" v-if="record.exception_flag > 2">已解除入驻协议</a-tag>
                            <a-tag color="red" v-if="record.exception_flag === 2">当前状态：待申报异常【代理商待确认①】</a-tag>
                            <a-tag color="red" v-if="record.exception_flag === 3">当前状态：待申报异常【代理商已确认，公司待确认②】</a-tag>
                            <a-tag color="pink" v-if="record.exception_flag === 4">当前状态：待申报异常【代理商、公司已确认，准备提交资料③】</a-tag>
                            <a-tag color="black" v-if="record.exception_flag === 5">当前状态：已申报异常【已交资料，待确认是否地址异常】</a-tag>
                            <a-tag color="black" v-if="record.exception_flag === 6">当前状态：人工已确认地址已异常</a-tag>
                            <a-tag color="red" v-if="record.exception_flag > 1"
                                @click="getExceptionLog(record, 1)">查看异常日志</a-tag>
                            <div class="mv-1x">
                                <a-popover trigger="click" v-model:open="record.isShowCompany"
                                    overlayClassName="customer-options-popover">
                                    <template #content>
                                        <p @click="handleDoubleNameClick(record.tyc_url)">跳转到天眼查</p>
                                        <p @click="handleDoubleNameClick(record.qcc_url)">跳转到企查查</p>
                                        <p
                                            @click="handleCopyClick(record.full_name + '的办理服务大厅网址为：' + record.fwzx_url + ' ，大厅可自助查看进度、下载营业执照、章程、银行开户资料，也可自助邮寄哦！！！请勿转发给直接客户，自行查阅即可！！！')">
                                            复制服务中心网址
                                        </p>
                                    </template>
                                    <div style="width: 100%"></div>
                                </a-popover>
                                <span class="mr-1x pointer"
                                    :style="record.status === 5 ? { textDecorationLine: 'line-through', fontSize: '14px' } : { fontSize: '14px' }"
                                    @click="
                                        (e) => {
                                            record.isShowCompany = false
                                            handleNameClick(e, record.full_name)
                                        }
                                    " @dblclick="
                                        () => {
                                            record.isShowCompany = true
                                        }
                                    " v-html="record.fullName"></span>
                                <a v-if="record.activity_info.activity"><a-badge-ribbon
                                        @click="showActivityDetail(record)" text="参加活动的订单" color="red">
                                    </a-badge-ribbon></a>
                                <a v-if="record.activity_info.activity && record.activity_info.status == 1"
                                    @click="addQueue(record)"><a-badge-ribbon text="立即排队免单" color="blue"
                                        style="margin-top: 30px">
                                    </a-badge-ribbon></a>
                                <template v-if="record.is_pay == 2">
                                    <template v-if="record.permission_show_pay == 1">
                                        <a-tag class="pointer" color="#f50"
                                            @click="onDirectPaymentClick(record)">未支付</a-tag>
                                    </template>
                                    <template v-else>
                                        <a-tag class="pointer" color="#f50"
                                            @click="onDirectPaymentClick(record)">未支付</a-tag>
                                    </template>
                                </template>
                                <a-tag color="#f50" v-else-if="record.is_pay == 3">待续费</a-tag>
                                <a-tag color="gray" v-else-if="record.is_pay == 4">报损</a-tag>
                                <a-tag color="cyan" v-else-if="record.is_pay == 1">已支付√</a-tag>
                                <a-tag color="orange" v-else>状态未知</a-tag>
                                <a-tag color="green" v-if="record.business_type == 2">同区迁入</a-tag>
                                <a-tag color="green" v-if="record.business_type == 3">跨区迁入</a-tag>
                                <a-tag color="green" v-if="record.fee_standard == 2">一次性付费</a-tag>
                                <a-tag color="green" v-if="record.registration_type == 2">裸地址</a-tag>
                                <a-tag color="blue" v-if="record.is_ybr == 1">一般纳税人</a-tag>
                                <a-tag class="pointer" color="#87d068" defaultBg="red"
                                    v-if="record.CustomerRefundOrder">
                                    <a-popover trigger="click" overlayClassName="customer-options-popover">
                                        <template #content>
                                            退款状态：<span style="color: orange"
                                                v-if="record.CustomerRefundOrder?.status == 0">退款待审核</span>
                                            <span v-if="record.CustomerRefundOrder?.status == 2">退款已驳回</span>
                                            <span v-if="record.CustomerRefundOrder?.status == 3">退款已撤销</span>
                                            <span style="color: green"
                                                v-if="record.CustomerRefundOrder?.status == 1">退款成功</span>
                                            <br />
                                            退款编号：{{ record.CustomerRefundOrder?.order_number }}
                                            <br />
                                            退款理由：{{ record.CustomerRefundOrder?.refund_remark }}
                                            <br />
                                            申请时间：{{ record.CustomerRefundOrder?.created_at }}
                                            <br />
                                            <div v-if="record.CustomerRefundOrder?.status == 1">
                                                退款时间：{{ record.CustomerRefundOrder?.updated_at }}
                                                <br />
                                                退款金额：{{ record.CustomerRefundOrder?.reality_refund_amount }}
                                            </div>
                                        </template>
                                        <span>有退款记录</span>
                                    </a-popover>
                                </a-tag>
                                <a-tag color="blue" v-else-if="record.mailing_type == 2">自动邮寄√</a-tag>
                                <a-tag color="blue" v-if="record.licenAcceptType == 2">工商局邮寄</a-tag>
                                <a-tag color="#f50" class="pointer"
                                    v-if="record.mailing_type == 2 && record.is_pay == 2"
                                    @click="payLogistics(record)">支付邮费</a-tag>
                                <!-- 宽寓大厦可以领章 -->
                                <a-tag color="blue" class="pointer"
                                    v-if="record.issong_seal == 1 && record.business_type == 1 && record.main_type != 2"
                                    @click="freeZhang(record)">点击领章</a-tag>
                                <a-tag color="blue" class="pointer" v-if="record.kezhang_auto == 1">刻章自动下单</a-tag>
                            </div>
                            <div style="font-size: 13px" class="mb-x">
                                <span class="pointer" @click="handleCopyClick(record.userPositionList[0].usrename[0])">
                                    {{ record.is_filiale == 1 ? '负责人' : record.main_type == 1 ? '法人代表姓名' :
                                        record.main_type == 4 ? '执行事务合伙人' : '负责人'
                                    }}：
                                    {{ record.userPositionList[0].usrename[0] ? record.userPositionList[0].usrename[0] :
                                        record.userPositionList[6].usrename[0] }}
                                </span>
                                <a-popover placement="right" :overlayInnerStyle="{
                                    padding: '25px'
                                }">
                                    <template #content>
                                        <a-watermark
                                            :content="'信息确认单 ' + (record.seller || record.ludan_person?.nickname || '')"
                                            :gap="[150, 150]" fontWeight="light">
                                            <div style="font-size: 16px; font-weight: 550; border-bottom: 1px dotted #ccc; padding-bottom: 8px"
                                                @click="copydetailinfo(record)">
                                                主体名称: {{ record.full_name
                                                }}<a-tag style="font-weight: normal"
                                                    :color="['非正常户注销', '注销'].includes(record.tax_status_name) ? 'red' : 'green'"
                                                    v-if="record.tax_status != 7">{{ record.tax_status_name }}
                                                    税务状态更新时间：{{
                                                        record.tax_check_time }}<span v-if="record.tax_type == 2">一般人认定时间：{{
                                                        record.tax_ybr_time
                                                    }}</span>
                                                </a-tag>
                                            </div>
                                            <div style="margin: 6px 0">地址：{{ record.full_address_number }}</div>
                                            <div style="margin: 6px 0" class="d-flex"
                                                v-if="record.history_names?.length > 0">
                                                <div>历史申请：</div>
                                                <div>
                                                    <div v-for="(item, index) in record.history_names" :key="index">
                                                        {{ item }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="margin: 6px 0" v-if="record.social_credit_code?.length > 0">
                                                统一社会信用代码：{{ record.social_credit_code }}</div>
                                            <div style="margin: 6px 0">
                                                <span class="mr-2x">入驻时间：{{ record.enter_starttime.substr(0, 10) }}
                                                    <span class="mv-1x">~</span> {{ record.enter_endtime.substr(0, 10)
                                                    }}
                                                    <span
                                                        v-if="enterTime(record.enter_endtime) && record.fee_standard == 1"
                                                        class="red">（{{ enterTime(record.enter_endtime) }}）</span>
                                                    <a-tag color="green">{{ record.fee_standard == 1 ? '按年续费' :
                                                        record.fee_standard == 2 ? '一次性付费' : '未知付费方式' }}</a-tag>
                                                    <a-tag color="blue" v-if="record.is_ybr == 1">一般纳税人</a-tag>
                                                </span>
                                                <span class="mr-2x" v-if="record.tyc_update_time">
                                                    <SyncOutlined style="color: #1677ff" /> {{ record.tyc_update_time
                                                    }}更新
                                                </span>
                                            </div>
                                            <div style="margin: 6px 0">
                                                <span v-if="record.verify_time" class="mr-2x">核准日期：{{
                                                    record.verify_time.substr(0, 10) }} </span>
                                                <span v-if="record.founding_time" class="mr-2x"> 成立日期：{{
                                                    record.founding_time.substr(0, 10) }} </span>
                                                <span v-if="record.created_at"> 录入系统时间：{{ record.created_at }} </span>
                                            </div>
                                            <div style="margin: 6px 0">
                                                <p class="mr-2x">
                                                    工商预留手机号码：<span style="color: red">{{ record.registration_mobile
                                                    }}</span> <a
                                                        @click="onUsbphoneClick(record, record.registration_mobile)">
                                                        <PhoneOutlined />
                                                    </a>
                                                </p>
                                            </div>
                                            <div style="margin: 6px 0; max-width: 800px">
                                                <span class="mr-2x">经营范围：<span v-html="record.businessScope"></span>
                                                </span>
                                            </div>
                                            <div style="margin: 16px 0">
                                                <a-table :columns="shareholderColumns" size="small" rowKey="name"
                                                    :pagination="false" :data-source="record.shareholder_list">
                                                    <template #bodyCell="res">
                                                        <template v-if="res.column.dataIndex == 'name'">
                                                            <div>
                                                                <div class="tablewraptr">
                                                                    {{ res.text }}
                                                                    <a-tag
                                                                        :color="res.record.hehuo_type == 1 ? 'blue' : 'green'"
                                                                        v-if="record.main_type == 4 && (res.record.type == 2 || res.record.is_shareholder == 1)">{{
                                                                            res.record.hehuo_type == 1 ? '有限合伙人' : '普通合伙人'
                                                                        }}</a-tag>
                                                                    <span class='onekeylimited'>
                                                                        <a-popconfirm v-if="user.id == 1"
                                                                            :title="`您确定将'${res.record.name}'限制入驻吗?`"
                                                                            placement="top" " @confirm="
                                                                                onekeylimit(res.record)">
                                                                            <a>限制入驻</a></a-popconfirm>
                                                                    </span>
                                                                </div>
                                                                <div v-if="res.record.phone_number">
                                                                    工商预留电话：{{
                                                                        res.record.phone_number }}
                                                                    <a
                                                                        @click="onUsbphoneClick(record, res.record.phone_number)">
                                                                        <PhoneOutlined />
                                                                    </a>
                                                                </div>
                                                                <div
                                                                    v-if="record.permission_look_gd_tel == 1 && res.record.phone_number_fengkong">
                                                                    实名风控电话：{{
                                                                        res.record.phone_number_fengkong }}
                                                                    <a
                                                                        @click="onUsbphoneClick(record, res.record.phone_number_fengkong)">
                                                                        <PhoneOutlined />
                                                                    </a>
                                                                </div>
                                                                <div v-if="res.record.id_card_number">
                                                                    <a v-if="res.record.id_card_number_show == 1"
                                                                        @click="idCardNumberClick(res.record, 0)"
                                                                        style="color:black">
                                                                        {{ res.record.id_card_number }}
                                                                        <EyeInvisibleOutlined />
                                                                    </a>
                                                                    <a v-else @click="idCardNumberClick(res.record, 1)"
                                                                        style="color:black">
                                                                        {{ res.record.id_card_number?.substr(0, 3) +
                                                                            '********' +
                                                                            res.record.id_card_number?.substr(15) }}
                                                                        <EyeOutlined />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <template v-if="res.column.dataIndex == 'address'">
                                                            <div>{{ res.record.address }}</div>
                                                            <div v-if="res.record.type == 1">
                                                                <a-button v-if="res.record.showidcard"
                                                                    @click="res.record.showidcard = 0"
                                                                    style="display: block; padding: 0"
                                                                    type="link">查看身份证照片</a-button>
                                                            </div>
                                                            <div v-if="res.record.type == 2">
                                                                <a-button v-if="res.record.showidcard"
                                                                    @click="res.record.showidcard = 0"
                                                                    style="display: block; padding: 0"
                                                                    type="link">查看营业执照照片</a-button>
                                                            </div>
                                                            <div v-if="!res.record.showidcard && res.record.type == 1">
                                                                <b-image :width="100"
                                                                    :src="$store.state.user.image_domain + res.record.id_card_back"></b-image>
                                                                <b-image :width="100"
                                                                    :src="$store.state.user.image_domain + res.record.id_card_front"></b-image>
                                                            </div>
                                                            <div v-if="!res.record.showidcard && res.record.type == 2">
                                                                <b-image :width="100"
                                                                    :src="$store.state.user.image_domain + res.record.business_license_url"></b-image>
                                                            </div>
                                                        </template>
                                                        <template v-if="res.column.dataIndex == 'position_name'">
                                                            <div v-if="record.main_type == 1" style="max-width: 230px">
                                                                <div v-if="res.text">
                                                                    <span v-for="(item, index) in res.text.split(',')"
                                                                        :key="index">
                                                                        <a-tag v-if="item?.length > 0" color="cyan">{{
                                                                            record.is_filiale == 1 ?
                                                                                item.replace(/法定代表人/g, '负责人') : item
                                                                        }}</a-tag>
                                                                    </span>
                                                                </div>
                                                                <div v-else>-</div>
                                                            </div>
                                                            <div v-else-if="record.main_type == 4"
                                                                style="max-width: 230px">
                                                                <div v-if="res.text">
                                                                    <span
                                                                        v-for="(item, index) in res.text.replace('法定代表人', '执行事务合伙人').split(',')"
                                                                        :key="index">
                                                                        <a-tag v-if="item?.length > 0" color="cyan">{{
                                                                            item
                                                                            }}</a-tag>
                                                                    </span>
                                                                </div>
                                                                <div v-else>-</div>
                                                            </div>
                                                            <div v-else>
                                                                <a-tag color="cyan">负责人</a-tag>
                                                            </div>
                                                        </template>
                                                        <template
                                                            v-else-if="res.column.dataIndex == 'investment_money'">
                                                            <div v-if="res.record.is_shareholder == 1">{{ res.text
                                                                }}<span v-if="res.text">万元</span>
                                                            </div>
                                                            <div v-else>-</div>
                                                        </template>
                                                        <template
                                                            v-else-if="res.column.dataIndex == 'subscribe_endtime'">
                                                            <div
                                                                v-if="(record.main_type == 1 || record.main_type == 4) && res.record.is_shareholder == 1">
                                                                <span v-if="record.is_filiale != 1">{{
                                                                    res.text?.substr(0, 10) }}</span>
                                                            </div>
                                                            <div v-else>-</div>
                                                        </template>
                                                    </template>
                                                </a-table>
                                            </div>
                                        </a-watermark>
                                    </template>

                                    <a type=" primary" style="margin-left: 10px">更多信息</a>
                                </a-popover>
                            </div>
                            <div style="margin-bottom: 8px" v-if="record.taglist">
                                Tags:
                                <a-tag :color="item.color" v-for="(item, index) in record.taglist" :key="index"
                                    @click="showYichang(record, item)">{{
                                        item.name
                                    }}</a-tag><a class="ml-1x" @click="onActionClick(record, 'AddTable')"
                                    v-if="data.user_permission != 'shixi'">
                                    <EditTwoTone />
                                </a>
                            </div>
                            <div class="mb-x" style="font-size: 12px" v-if="record.history_names?.length > 0">
                                <span> 历史申请: </span>
                                <div v-for="(item, index) in record.history_names" :key="index">
                                    {{ item }}
                                </div>
                            </div>
                            <div style="height: 25px; font-size: 13px" v-if="data.user_permission != 'shixi'">
                                <div class="deng">
                                    <a class="mr-1x" v-if="
                                        user.id == 1 ||
                                        ((record.customer_work_order_status.after_status == '1004' || record.customer_work_order_status.after_status == '7005') && record.customer_work_order_status.recordfrom != 0)
                                    " :href="`https://hncs.cskaiyela.com/admin/v1/customerAutoLogin?token=${token}&customer_id=${record.id}`"
                                        target="_blank" v-hasRole="['root', 'platform', 'seller']">
                                        登录</a>
                                    <a class="mr-1x" v-if="record.is_filiale == 1"
                                        :href="`https://hncs.cskaiyela.com/admin/v1/customerAutoLogin?token=${token}&customer_id=${record.id}&type=1`"
                                        target="_blank" v-hasRole="['root', 'platform', 'seller']">外省总公司的分公司设立登录</a>
                                    <a-popconfirm title="确定推送主体当前状态给续费联系人及销售?" @confirm="handleTuiSYBJ(record)">
                                        <a
                                            v-if="record.customer_work_order_status?.after_status_name != '已办结'">推送为已办结</a>
                                    </a-popconfirm>
                                    <a v-if="record.signatureStatus == 1" v-hasRole="['root']" style="float: right"
                                        @click="onActionClick(record, 'SignatureStatus')">查看签名状态</a>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'full_address_number'">
                        <div class="pointer" v-if="record.permission_edit_addr == 1">
                            <div style="border-bottom: 1px dashed #ccc">
                                <div v-if="record.isEdit">
                                    地址编号：<a-input style="width: 130px; margin-bottom: 5px"
                                        v-model:value="record.full_address_dzcode" placeholder="请输入地址编号"
                                        name="full_address_dzcode"></a-input>
                                    <CheckOutlined @click="saveDzcode(record)" class="ml-1x" />
                                </div>
                                <span v-else @click="editdzcode(record)" class="pointer"><span
                                        v-if="record.full_address_dzcode">最终地址编号：<span
                                            style="font-size: 20px; color: red">{{ record.full_address_dzcode }}</span>
                                        <EditOutlined :spin="record.permission_addr_upload == 2" />
                                    </span><span v-else>请输入地址编号：<span>XXX</span>
                                        <EditOutlined spin />
                                    </span>
                                </span>
                            </div>
                            <div>
                                最终地址表述：<span
                                    @click="handleCopyClick(record.full_address_prefix + (record.full_address_dzcode ?? 'XXX') + (record.full_address_postfix == '无' ? '' : record.full_address_postfix))">
                                    <div v-if="record.raw_address?.length > 0" style="border-bottom: 1px dashed #ccc">
                                        由：{{
                                            record.raw_address }}</div>
                                    <div>
                                        <span v-if="record.raw_address?.length > 0">迁到：</span>{{
                                            record.full_address_prefix
                                        }}{{ record.full_address_dzcode ?? 'XXX'
                                        }}{{ record.full_address_postfix == '无' ? '' : record.full_address_postfix }}
                                    </div>
                                </span>
                            </div>
                        </div>
                        <div @click="handleCopyClick(text)" class="pointer" v-else>
                            <div v-if="record.raw_address?.length > 0" style="border-bottom: 1px dashed #ccc">由：{{
                                record.raw_address }}</div>
                            <div>
                                <span v-if="record.raw_address?.length > 0">迁到：</span>
                                <span v-if="text">{{ text }}</span>
                                <span v-else><a-button type="primary" size="small">等待地址方确认</a-button></span>
                            </div>
                        </div>
                        <template
                            v-if="record.permission_update_addr == 1 && record.customer_work_order_status?.after_status_name != '已办结'">
                            <!-- 手动上传资料地址方 -->
                            <div style="margin: 5px 0">
                                <a-tag color="green" v-if="record.permission_addr_upload == 1">地址方已上传资料</a-tag>
                                <a-tag color="orange" v-else-if="record.is_auto == 2">当前资料未确定，建议等待确认后再上传地址资料</a-tag>
                                <a-tag color="cyan" v-else-if="record.is_auto == 1">资料已确定，请地址方上传地址资料</a-tag>
                            </div>
                            <a-button type="primary" @click.stop="uploadDzzl(record)" danger size="small">
                                <UploadOutlined />传资料
                            </a-button>
                            <a-button type="primary" style="color: #fff; background: rgb(59, 89, 153)" size="small"
                                class="ml-1x"
                                v-if="data.user_permission == 'admin' && record.permission_addr_upload == 2"
                                @click="cuidizhifang(record)" :loading="record.cuidizhifangLoading">
                                <NotificationOutlined />通知地址方出资料
                            </a-button>
                            <a-button type="primary" class="ml-1x" size="small"
                                v-if="record.permission_addr_upload == 1" @click="cuiSeller(record)">通知销售录单
                                <NotificationOutlined />
                            </a-button>
                        </template>
                        <template v-if="record.permission_update_addr == 2">
                            <!-- 手动上传资料代理商 -->
                            <div style="margin: 5px 0">
                                <a-tag color="green" v-if="record.permission_addr_upload == 1">地址方已上传资料</a-tag>
                                <a-tag color="orange"
                                    v-else-if="record.is_auto == 2">当前资料未确定，地址方不会上传资料，如资料已确定，请将左侧开关打开</a-tag>
                                <a-tag color="cyan" v-else-if="record.is_auto == 1">资料已确定，等待地址方上传地址资料</a-tag>
                            </div>
                            <a-button type="primary" style="color: #fff; background: rgb(59, 89, 153)" size="small"
                                v-if="record.permission_addr_upload == 2" @click="cuidizhifang(record)"
                                :loading="record.cuidizhifangLoading">通知地址方出资料
                                <NotificationOutlined />
                            </a-button>
                        </template>
                        <a-row v-hasRole="['root', 'platform', 'seller']">
                            <a-col :span="4">
                                备注：
                            </a-col>
                            <a-col :span="20">
                                <div v-if="!record.remarkEdit">
                                    <a-tag color="red" class="pointer" v-if="record.common_remark">{{
                                        record.common_remark
                                    }}</a-tag>
                                    <a class="ml-1x" @click="() => {
                                        record.remark_new = record.common_remark
                                        record.remarkEdit = true
                                    }">
                                        <EditTwoTone />
                                    </a>
                                    <a class="ml-1x" @click="() => {
                                        record.remark_new = ''; editRemark(record)
                                    }">
                                        <DeleteTwoTone />
                                    </a>
                                </div>
                                <div v-if="record.remarkEdit">
                                    <a-input style=" margin-bottom: 5px" v-model:value="record.remark_new" name="remark"
                                        placeholder="请输入"></a-input>
                                    <div>
                                        <a-button class="mr-2x" @click="
                                            () => {
                                                record.remarkEdit = false
                                            }
                                        " size="small">取消</a-button>
                                        <a-button @click="editRemark(record)" size="small" type="primary">确认</a-button>
                                    </div>
                                </div>
                            </a-col>
                        </a-row>
                        <div
                            v-if="record.exception_flag == 2 || record.exception_flag == 3 || record.exception_flag == 4">
                            <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                :cancel-button-props="{ size: 'middle' }" title="待申报地址异常，确定提交申报吗？" placement="top"
                                @openChange="
                                    (e) => {
                                    }
                                " @confirm="change_exception_seller(record)" v-if="record.exception_flag == 2">
                                <template #description>
                                    <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout"
                                        ref="attrformRef">
                                        <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 17 }" label="备注"
                                            required name="remark">
                                            <a-input v-model:value="data.exception_remark" placeholder="申报理由"></a-input>
                                        </a-form-item>
                                        <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 17 }" label="附件(选填)"
                                            name="exception_url">
                                            <Upload :upload_path="record.upload_path + '申报异常/'" uploadType="text"
                                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                                :limitation="3" v-model:value="data.exception_url" uploadText="上传附件">
                                            </Upload>
                                        </a-form-item>
                                    </a-form>
                                </template>
                                <a-row>
                                    <a-col :span="10">
                                        <a-statistic-countdown title="代理商确定待申报异常剩余时间"
                                            :value="record.exception_flag_seller_endtime * 1000"
                                            format="HH:mm:ss:SSS" />
                                    </a-col>
                                    <a-col :span="14"><a-badge-ribbon text="代理商点击确认申报" color="green"
                                            style="cursor: pointer;">
                                        </a-badge-ribbon></a-col>
                                </a-row>
                            </a-popconfirm>
                            <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                :cancel-button-props="{ size: 'middle' }" title="待申报地址异常，确定客户不配合吗？" placement="top"
                                @openChange="
                                    (e) => {
                                    }
                                " @confirm="change_exception_fws(record)"
                                v-if="data.user_permission == 'admin' || data.user_permission == 'platform'">
                                <template #description>
                                    <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout"
                                        ref="attrformRef">
                                        <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 17 }" label="备注"
                                            required name="remark">
                                            <a-input v-model:value="data.exception_remark" placeholder="申报理由"></a-input>
                                        </a-form-item>
                                        <a-form-item :labelCol="{ span: 3 }" :wrapperCol="{ span: 17 }" label="附件(选填)"
                                            name="exception_url">
                                            <Upload :upload_path="record.upload_path + '申报异常/'" uploadType="text"
                                                :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                                :limitation="3" v-model:value="data.exception_url" uploadText="上传附件">
                                            </Upload>
                                        </a-form-item>
                                    </a-form>
                                </template>
                                <a-button type="primary" size="small" danger
                                    v-if="record.exception_flag == 3">公司点击确认申报</a-button>
                            </a-popconfirm>
                            <a-badge-ribbon text="已确认，可以申报异常了" color="pink" style="cursor: pointer;"
                                v-if="record.exception_flag == 4"></a-badge-ribbon>
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'status'">
                        <div
                            v-if="record.customer_work_order_status?.after_status == 1 && record.permission_show_edit == 1">
                            <a-switch v-model:checked="record.is_auto_switch" checked-children="资料已确定，资料员可以录单了√"
                                un-checked-children="还有资料未确定，资料员不要录单"
                                style="margin-bottom: 6px; font-size: 10px; min-width: 200px"
                                @click="change_order_preparation_mode(record)" size="small"
                                title="只有这里是开启的，资料员才会录单，否则不录单" />
                        </div>
                        <div v-if="record.customer_work_order_status">
                            <p class="mb-x">
                                <a-badge color="#87d068"
                                    v-if="record.customer_work_order_status.after_status_name == '已办结'"
                                    status="success" />
                                <a-badge color="#108ee9" v-else status="processing" />
                                <template v-if="
                                    record.permission_show_status == 2 &&
                                    (record.customer_work_order_status?.after_status_name == '做单中' ||
                                        record.customer_work_order_status?.after_status_name == '待签名' ||
                                        record.customer_work_order_status?.after_status_name == '材料检查中' ||
                                        record.customer_work_order_status?.after_status_name == '有问题待协商停止录单')
                                ">
                                    已录单</template>
                                <template v-else-if="data.user_permission == 'shixi'">
                                    <!-- 1003是公司的材料检查中，7080是待签名。实习代理商的这两个状态推迟15分钟 -->
                                    <span v-if="
                                        ((record.customer_work_order_status?.after_status == '1003' && record.main_type != 2) || (record.customer_work_order_status?.after_status == '7080' && record.main_type == 2)) &&
                                        dayjs().diff(dayjs(record.customer_work_order_status?.created_at), 'minute') < 15 &&
                                        record.platform_id != 18 &&
                                        record.platform_id != 23 &&
                                        ![64, 226, 97, 86, 532].includes(user.id)
                                    ">
                                        交资料中，请稍等
                                    </span>
                                    <span v-else>{{ record.customer_work_order_status?.after_status_name }}
                                        <p
                                            v-if="record.customer_work_order_status?.after_status == '1004' || record.customer_work_order_status?.after_status == '7005'">
                                            {{ record.customer_work_order_status.reason }}
                                        </p>
                                        <p style="font-size: 12px; border: 1px dashed #ccc; padding: 5px; color: rgb(177 80 80)"
                                            v-if="record.customer_work_order_status.beizhu">
                                            {{ record.customer_work_order_status?.beizhu }}
                                        </p>
                                    </span>
                                </template>
                                <template v-else>
                                    <span
                                        @click="handleCopyClick(record.full_name + ' ' + record.customer_work_order_status?.after_status_name)"
                                        style="cursor: pointer;">{{ record.customer_work_order_status?.after_status_name
                                        }}</span>
                                </template>
                                <a-popconfirm title="确定推送主体当前状态给续费联系人及销售?" @confirm="handleTuiS(record)"
                                    v-if="data.user_permission == 'admin'">
                                    <a v-if="record.customer_work_order_status?.after_status_name && record.customer_work_order_status?.after_status_name != '已办结'"
                                        class="ml-1x">推送</a>
                                </a-popconfirm>

                                <a-switch v-if="
                                    [7080, 7081, 7002, 7005, 7009, 7001, 7081, 7082, 4, 1003, 1004, 1005, 1006, 1007, 1008, 1010, 1011, 1013].includes(record.customer_work_order_status.after_status) &&
                                    record.permission_show_edit == 1 &&
                                    data.user_permission != 'shixi'
                                " v-model:checked="record.is_auto_switch" checked-children="维护状态"
                                    un-checked-children="不维护" size="small" style="margin: 0 0 4px 5px"
                                    suffixTitle="回车或失去焦点后可以添加多个关键词" @click="change_order_preparation_mode(record)"
                                    title="维护表示：签字完成后，行政会直接给提交；
不维护表示，则表示即使签字完成了，也不会给提交，需要人工微信沟通行政提交。
我们严格遵从客户意愿，请谨慎调整状态。" />

                                <a class="ml-1x"
                                    v-if="record.customer_work_order_status?.after_status == 2 || record.customer_work_order_status?.after_status == 3"
                                    @click="cancelPushOrder(record)">撤销通知做单</a>
                            </p>
                            <p v-if="record.permission_show_tzzd == 1 && data.user_permission != 'shixi'" class="mb-x">
                                状态改变时间：{{
                                    record.customer_work_order_status?.created_at }}</p>
                            <p v-if="record.permission_show_tzzd == 1 && record.customer_work_order_status.after_status_name != '已办结'"
                                class="mb-x">
                                上次查询时间：{{
                                    record.customer_work_order_status?.updated_at }}</p>
                        </div>
                        <div class="d-flex flex-ac" style="justify-content: space-between">
                            <a @click="onViewLogClick(record, 2)" v-if="record.permission_show_status == 1">状态</a>
                            <a @click="onViewLogClick(record, 3)" :offset="[5, -5]">工单</a>
                            <a-badge :count="record.chat_read_count" :offset="[5, -5]"> <a
                                    @click="onViewLogClick(record, 4)">微信沟通</a>
                            </a-badge>
                            <a @click="onViewLogClick(record, 1)" :offset="[5, -5]">日志</a>
                        </div>

                    </template>

                    <template v-else-if="column.dataIndex === 'seller'">
                        <div class="changerole">
                            <div v-hasUser="[record.seller_id, record.ludan_id]">
                                <div>
                                    <p class="mb-x ellipsis-12" v-if="record.seller">
                                        代理商：{{ record.seller ? record.seller : '-' }} <a
                                            @click="changerole(record.seller_id)"
                                            v-if="user.id == 1 && record.seller_id > 0" class="deng">切换身份</a>
                                    </p>
                                </div>
                                <div>
                                    <p class="mb-x ellipsis-12" v-if="record.ludan_person">
                                        录单人：<a-avatar :size="18" :src="record.ludan_person?.wx_headimgurl">
                                            <template #icon>
                                                <UserOutlined />
                                            </template> </a-avatar>{{ record.ludan_person?.nickname }}<a
                                            @click="changerole(record.ludan_id)"
                                            v-if="user.id == 1 && record.ludan_id > 0" class="deng">切换身份</a>
                                    </p>
                                </div>
                                <p class="mb-x">
                                    <a-popover placement="left" :overlayInnerStyle="{
                                        padding: '25px'
                                    }">
                                        <template #content>
                                            <div
                                                style="font-size: 16px; font-weight: 550; border-bottom: 1px dotted #ccc; padding-bottom: 8px">
                                                渠道详细情况：</div>
                                            <div style="width: 450px; line-height: 26px">
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">工商预留手机号码：</a-col>
                                                    <a-col :span="14">{{ record.registration_mobile }}<a
                                                            @click="handleCopyClick(record.registration_mobile)"
                                                            class="ml-1x">
                                                            <CopyOutlined />
                                                        </a><a
                                                            @click="onUsbphoneClick(record, record.registration_mobile)">
                                                            <PhoneOutlined />
                                                        </a></a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">续费联系人手机号码：</a-col>
                                                    <a-col :span="14">
                                                        <div v-if="record.isEditXftel">
                                                            <a-input style="width: 130px; margin-bottom: 5px"
                                                                v-model:value="record.new_xftel" @change="
                                                                    (v) => {
                                                                        phoneChange(v, 'new_xftel', record)
                                                                    }
                                                                " name="new_xftel" placeholder="请输入手机号码"></a-input>
                                                            <div>
                                                                <a-button class="mr-2x" @click="
                                                                    () => {
                                                                        record.isEditXftel = false
                                                                    }
                                                                " size="small">取消</a-button>
                                                                <a-button @click="editPhoneChange(record)" size="small"
                                                                    type="primary">确认</a-button>
                                                            </div>
                                                        </div>
                                                        <span v-else @click="
                                                            () => {
                                                                record.new_xftel = record.xftel
                                                                record.isEditXftel = true
                                                            }
                                                        " class="pointer phone_number">{{ record.xftel
                                                            || '无' }}
                                                            <EditTwoTone />
                                                        </span><a @click="onUsbphoneClick(record, record.xftel)">
                                                            <PhoneOutlined />
                                                        </a>
                                                    </a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司名称：</a-col>
                                                    <a-col :span="14">{{ record.finance_company_name }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司统一社会信用代码：</a-col>
                                                    <a-col :span="14">{{ record.finance_social_credit_code }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司对接人姓名：</a-col>
                                                    <a-col :span="14">{{ record.finance_contact_name }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司对接人其他号码：</a-col>
                                                    <a-col :span="14">{{ record.finance_contact_phone }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司对接人微信昵称：</a-col>
                                                    <a-col :span="14"><a-avatar size="small"
                                                            :src="record.xf_person?.headimgurl"
                                                            v-if="!!record.finance_contact_wechat_nickname">
                                                            <template #icon>
                                                                <UserOutlined />
                                                            </template> </a-avatar>{{
                                                                record.finance_contact_wechat_nickname }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司对接人微信号：</a-col>
                                                    <a-col :span="14">{{ record.finance_contact_wechat_account
                                                    }}<a v-if="!!record.finance_contact_wechat_account"
                                                            @click="handleCopyClick(record.finance_contact_wechat_account)"
                                                            class="ml-1x">
                                                            <CopyOutlined />
                                                        </a></a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">备注：</a-col>
                                                    <a-col :span="14">{{ record.remark }}</a-col>
                                                </a-row>
                                            </div>
                                        </template>
                                        续费人：<a-avatar :size="18" :src="record.xf_person?.headimgurl">
                                            <template #icon>
                                                <UserOutlined />
                                            </template>
                                        </a-avatar>
                                    </a-popover>

                                    {{ record.xf_person?.nickname }}
                                    <span v-if="!record.xf_person">未关注公众号<a-image :width="18"
                                            src="https://hncs.cskaiyela.com/wxewm.jpg" /></span>
                                </p>
                            </div>
                            <span title='创建时间'>{{ record.created_at }}</span><a @click="handleCopyClick(record.xftel)"
                                @dblclick="onUsbphoneClick(record, record.xftel)" class="ml-1x"
                                v-hasUser="[record.seller_id, record.ludan_id]">
                                <CopyOutlined />
                            </a>
                        </div>
                    </template>

                    <template v-else-if="column.dataIndex === 'action'">
                        <div class="mb-x">
                            <a-button type="primary" stype="background:#108ee9" :data-id="record.id"
                                @click="onPushOrderMakingClick(record)" size="small">正式提交订单</a-button>
                            <a-divider type="vertical" />
                            <a-popover @openChange="
                                (val) => {
                                    optionsVisibleChange(val, record)
                                }
                            " trigger="click" v-model:open="record.isShowOptions"
                                overlayClassName="customer-options-popover">
                                <template #content>
                                    <p @click="onActionClick(record, 'PayCenter')">
                                        <!-- v-if="record.permission_show_pay == 1"> -->
                                        支付中心
                                    </p>
                                    <p @click="onActionClick(record, 'Invoice')">
                                        发票申请
                                    </p>
                                    <p @click="onActionClick(record, 'XftelTixian')">
                                        部分提现(业务来源方提现)
                                    </p>

                                    <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                        :cancel-button-props="{ size: 'middle' }" title="属性调整控制台" placement="left"
                                        @openChange="
                                            (e) => {
                                                openAttrChange(e, record)
                                            }
                                        " @confirm="submitAttrAdjust(record)">
                                        <template #description>
                                            <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout"
                                                ref="attrformRef">
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="属性名称" required>
                                                    <a-select allow-clear style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择待调整的属性名称" v-model:value="customer_attr.name"
                                                        required>
                                                        <a-select-option value="fee_standard"> 收费标准
                                                        </a-select-option>
                                                        <a-select-option value="dls_xf_price"> 续费价格（{{
                                                            record.seller }}拿货价） </a-select-option>
                                                        <a-select-option value="enter_starttime"> 入驻开始日期
                                                        </a-select-option>
                                                        <a-select-option value="enter_endtime"> 入驻到期日期
                                                        </a-select-option>
                                                        <a-select-option value="founding_time"> 成立日期
                                                        </a-select-option>
                                                        <a-select-option value="verify_time"> 核准日期
                                                        </a-select-option>
                                                        <a-select-option value="yifang_name"> 租房合同乙方姓名
                                                        </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <div v-if="customer_attr.name == 'fee_standard'">
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整前值" required>
                                                        <a-radio-group v-model:value="customer_attr.old_fee_standard"
                                                            button-style="solid">
                                                            <a-radio-button :value="1"
                                                                v-if="record.fee_standard == 1">按年收费</a-radio-button>
                                                            <a-radio-button :value="2"
                                                                v-if="record.fee_standard == 2">一次性收费</a-radio-button>
                                                        </a-radio-group>
                                                    </a-form-item>
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整后值" required>
                                                        <a-radio-group v-model:value="customer_attr.fee_standard"
                                                            button-style="solid">
                                                            <a-radio-button :value="1"
                                                                v-if="record.fee_standard == 2">按年收费</a-radio-button>
                                                            <a-radio-button :value="2"
                                                                v-if="record.fee_standard == 1">一次性收费</a-radio-button>
                                                        </a-radio-group>
                                                    </a-form-item>
                                                </div>
                                                <div v-else-if="customer_attr.name == 'dls_xf_price'">
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整前值" required> ￥{{ record.dls_xf_price }}
                                                    </a-form-item>
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整后值" required>
                                                        <a-input v-model:value="customer_attr.dls_xf_price" prefix="￥"
                                                            suffix="元" style="width: 250px"
                                                            placeholder="请输入续费价格"></a-input>
                                                    </a-form-item>
                                                </div>
                                                <div v-else-if="customer_attr.name == 'enter_starttime'">
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整前值" required> {{ record.enter_starttime }}
                                                    </a-form-item>
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整后值" required>
                                                        <a-date-picker v-model:value="customer_attr.enter_starttime"
                                                            placeholder="选择入驻开始日期"
                                                            :popupStyle="{ 'z-index': 9999 }"></a-date-picker>
                                                    </a-form-item>
                                                </div>

                                                <div v-else-if="customer_attr.name == 'enter_endtime'">
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整前值" required> {{ record.enter_endtime }}
                                                    </a-form-item>
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整后值" required>
                                                        <a-date-picker v-model:value="customer_attr.enter_endtime"
                                                            placeholder="选择入驻结束日期"
                                                            :popupStyle="{ 'z-index': 9999 }"></a-date-picker>
                                                    </a-form-item>
                                                </div>
                                                <div v-else-if="customer_attr.name == 'founding_time'">
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整前值" required> {{ record.founding_time }}
                                                    </a-form-item>
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整后值" required>
                                                        <a-date-picker v-model:value="customer_attr.founding_time"
                                                            placeholder="选择成立日期"
                                                            :popupStyle="{ 'z-index': 9999 }"></a-date-picker>
                                                    </a-form-item>
                                                </div>
                                                <div v-else-if="customer_attr.name == 'verify_time'">
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整前值" required> {{ record.verify_time }}
                                                    </a-form-item>
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整后值" required>
                                                        <a-date-picker v-model:value="customer_attr.verify_time"
                                                            placeholder="选择核准日期"
                                                            :popupStyle="{ 'z-index': 9999 }"></a-date-picker>
                                                    </a-form-item>
                                                </div>
                                                <div v-else-if="customer_attr.name == 'yifang_name'">
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整前值" required> {{ record.yifang_name }}
                                                    </a-form-item>
                                                    <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                        label="调整后值" required>
                                                        <a-input v-model:value="customer_attr.yifang_name"
                                                            style="width: 250px" placeholder="请输入乙方名称"></a-input>
                                                    </a-form-item>
                                                </div>

                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整理由" required name="remark">
                                                    <a-input v-model:value="customer_attr.remark" style="width: 250px"
                                                        placeholder="调整理由"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="相关附件(选填)" name="template_url">
                                                    <Upload :upload_path="record.upload_path + '属性调整/'"
                                                        uploadType="text"
                                                        :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                                        :limitation="1" v-model:value="customer_attr.annex_url"
                                                        uploadText="上传附件">
                                                    </Upload>
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>属性调整</p>
                                    </a-popconfirm>
                                    <p @click="onActionClick(record, 'Refund')">退款</p>
                                    <!-- <p v-if="record.is_pay != 2 && record.fee_standard != 2" @click="onActionClick(record, 'PayCenter')">地址续费</p> -->
                                    <PushCustPaid :tableColumnsData="record">
                                        <p>推送至微信收款</p>
                                    </PushCustPaid>

                                    <!-- <p v-if="!record.first_pay_time" @click="onDirectPaymentClick(record)">支付第一次入驻服务费</p> -->
                                    <a-popover trigger="click" overlayClassName="customer-options-popover"
                                        v-if="data.user_permission != 'shixi'">
                                        <template #content>
                                            <p @click="onTaxInquiryClick(record, 1)">税务基础情况查询</p>
                                            <p @click="onTaxInquiryClick(record, 2)">一般纳税人查询</p>
                                            <p @click="onTaxInquiryClick(record, 3)">税务登记基本信息查询</p>
                                        </template>
                                        <p>税务查询</p>
                                    </a-popover>
                                    <p @click="onActionClick(record, 'AddTable')"
                                        v-if="data.user_permission != 'shixi'">
                                        标签管理</p>
                                    <p @click="onActionClick(record, 'SFMail')" v-if="record.permission_show_edit == 1">
                                        发快递
                                    </p>
                                    <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                        :cancel-button-props="{ size: 'middle' }" title="确定锁定不列入异常?" placement="left"
                                        @openChange="
                                            (e) => {
                                                openLockExceptionChange(e, record)
                                            }
                                        " @confirm="submitLockException(record)"
                                        v-if="data.user_permission != 'shixi'">
                                        <template #description>
                                            <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="锁定理由" style="width: 800px" required>
                                                    <a-input v-model:value="lockException.reason" placeholder="请输入理由"
                                                        style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="锁定起止时间" style="width: 800px" required>
                                                    <div class="d-flex">
                                                        <a-range-picker :show-time="{ defaultValue: arrayMonent }"
                                                            :popupStyle="{ 'z-index': 9999 }" :value="lockRangTime"
                                                            @change="lockRangTimeChange"
                                                            :format="format"></a-range-picker>
                                                    </div>
                                                </a-form-item>

                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="锁定理由图片" style="width: 800px" labelWrap="true">
                                                    <Upload :upload_path="record.upload_path"
                                                        :accept="['png', 'jpg', 'jpeg', 'pdf']"
                                                        uploadType="picture-card" :limitation="99"
                                                        :customerName="record.full_name"
                                                        v-model:value="lockException.url" uploadText="上传锁定理由图片">
                                                    </Upload>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="备注" style="width: 800px">
                                                    <a-input v-model:value="lockException.remark"
                                                        placeholder="请输入备注（可填）" style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item style="width: 800px"> 提示：锁定后无法列入异常。 </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>申请锁定不列异常</p>
                                    </a-popconfirm>
                                    <ChangeExceptionflag :customerData="record" @change="(exception_flag, endtime) => {
                                        change_exception_flag(exception_flag, endtime, record)
                                    }" v-if="data.user_permission != 'shixi'"
                                        @update:loading="val => { data.loading = val; }">
                                        <p>调整异常状态</p>
                                    </ChangeExceptionflag>
                                    <a-popconfirm title="确定申报地址异常?" placement="left" @openChange="
                                        (e) => {
                                            openAnomalyChange(e, record, 1)
                                        }
                                    " @confirm="listed_in_anomaly(record)" v-if="data.user_permission != 'shixi'"
                                        ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                        :cancel-button-props="{ size: 'middle' }">
                                        <template #description>
                                            <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="申报地址异常理由" style="width: 800px" required>
                                                    <a-input v-model:value="record.anomaly_desc" placeholder="请输入理由"
                                                        style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="失联的短信电话截图" style="width: 800px" labelWrap="true">
                                                    <Upload :upload_path="record.upload_path"
                                                        :accept="['png', 'jpg', 'jpeg', 'pdf']"
                                                        uploadType="picture-card" :limitation="99"
                                                        :customerName="record.full_name"
                                                        v-model:value="record.anomaly_url" uploadText="上传失联的短信、电话截图">
                                                    </Upload>
                                                </a-form-item>
                                                <a-form-item label="操作" :labelCol="{ span: 5 }"
                                                    :wrapperCol="{ span: 19 }" style="width: 800px" required>
                                                    <a-radio-group v-model:value="record.doaction_type">
                                                        <a-radio :value="1"> 直接列入(上工单，外勤会直接去送材料，谨慎操作)
                                                        </a-radio><br />
                                                        <a-radio :value="2"> 仅下载列入异常申报资料 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="备注" style="width: 800px">
                                                    <a-input v-model:value="record.anomaly_remark"
                                                        placeholder="请输入备注（可填）" style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item style="width: 800px">
                                                    提示：申报地址异常后还需要递交资料才可以正式列入，请知悉！确定后将自动生成列入异常模板，也可前往档案管理里面再次下载！
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>申报地址异常</p>
                                    </a-popconfirm>
                                    <p @click="oneKeyKezhang(record)">一键刻章</p>
                                    <p @click="onCopyClick(record)">复制</p>
                                    <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                        :cancel-button-props="{ size: 'middle' }" title="确定删除?" placement="left"
                                        @openChange="
                                            (e) => {
                                                openDeleteChange(e, record)
                                            }
                                        " @confirm="handleDelete(record)">
                                        <template #description>
                                            <a-form style="width: 600px" v-bind="formLayout">
                                                <a-form-item label="删除原因" required>
                                                    <a-radio-group v-model:value="record.deleteType">
                                                        <a-radio :value="1">废弃</a-radio>
                                                        <a-radio :value="2">该主体已注销</a-radio>
                                                        <a-radio :value="3">该主体已迁出</a-radio>
                                                        <a-radio :value="4">报损</a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item label="理由" required v-if="record.deleteType == 1">
                                                    <a-input v-model:value="record.desc" placeholder="请输入理由">
                                                    </a-input>
                                                </a-form-item>
                                                <a-form-item label="理由" v-else>
                                                    <a-input v-model:value="record.desc" placeholder="请输入理由">
                                                    </a-input>
                                                </a-form-item>
                                                <a-form-item label="备注"> 删除后可在主体回收站中撤回删除 </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>删除</p>
                                    </a-popconfirm>
                                    <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                        :cancel-button-props="{ size: 'middle' }" title="撤销确认" placement="left"
                                        @confirm="handleChexiao(record)">
                                        <template #description>
                                            您确定要撤销这个已做上去的单吗？撤销时间比较长，请耐心等待，成功后状态会变成已撤销。
                                        </template>
                                        <p>撤销</p>
                                    </a-popconfirm>
                                </template>
                                <a @click="
                                    () => {
                                        record.isShowOptions = true
                                    }
                                ">更多</a>
                            </a-popover>
                        </div>
                        <a @click="onActionClick(record, 'Record')">档案管理</a>
                        <a-divider type="vertical" />
                        <a-popover trigger="click" overlayClassName="customer-options-popover">
                            <template #content v-if="data.user_permission != 'shixi'">
                                <div v-for="(item, index) in record.DownType" :key="index">
                                    <a-popover trigger="click" overlayClassName="customer-options-popover"
                                        v-if="item.children?.length > 0" placement="left">
                                        <template #content>
                                            <div v-for="(downLeaseItem, downLeaseIndex) in item.children"
                                                :key="downLeaseIndex" @click="downLease(downLeaseItem)">
                                                <div v-if="downLeaseItem.children?.length > 0">
                                                    {{ downLeaseItem.name }}
                                                </div>
                                                <p v-else>
                                                    {{ downLeaseItem.name }}
                                                </p>
                                                <div v-if="downLeaseItem.children?.length > 0">
                                                    <p v-for="(downItem, downIndex) in downLeaseItem.children"
                                                        :key="downIndex" @click="downLease(downItem)">
                                                        {{ downItem.name }}
                                                    </p>
                                                </div>
                                            </div>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popover>
                                    <a-popconfirm v-else-if="item.id == 4" title="租赁合同" placement="left" @openChange="
                                        (e) => {
                                            openLeaseChange(e, record)
                                        }
                                    " @confirm="downLeaseLease(record, item)">
                                        <template #description>
                                            <a-form style="width: 400px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="是否盖公章" required>
                                                    <a-radio-group v-model:value="leaseData.gz" @change="changeLeaseGz">
                                                        <a-radio :value="1"> 有公章 </a-radio>
                                                        <a-radio :value="2"> 无公章 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="是否签字" required>
                                                    <a-radio-group v-model:value="leaseData.qz">
                                                        <a-radio :value="2"> 无签字 </a-radio>
                                                        <a-radio :value="1" v-if="leaseData.gz == 1"> 有签字 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="合同租金是否遮挡" required>
                                                    <a-radio-group v-model:value="leaseData.zd">
                                                        <a-radio :value="1"> 遮挡 </a-radio>
                                                        <a-radio :value="2"> 未遮挡 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="租金" v-if="leaseData.zd == 2" required>
                                                    <a-input v-model:value="leaseData.zujin" placeholder="请输入合同价格"
                                                        style="width: 150px" prefix="￥" suffix="元"> </a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="入驻类型" required>
                                                    <a-radio-group v-model:value="leaseData.fee_standard">
                                                        <a-radio :value="1"> 按年收费 </a-radio>
                                                        <a-radio :value="2"> 一次性收费 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="是否显示电话" required>
                                                    <a-radio-group v-model:value="leaseData.tel">
                                                        <a-radio :value="2"> 不显示 </a-radio>
                                                        <a-radio :value="1"> 显示 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>

                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="租期" required>
                                                    <a-select allow-clear v-if="leaseData.is_diy != 1"
                                                        style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择租期" v-model:value="leaseData.zqrange" required
                                                        @change="changzq">
                                                        <a-select-option :value="zqitem.start + '~' + zqitem.end"
                                                            v-for="zqitem in record.zqlist">
                                                            {{
                                                                zqitem.start }}~{{
                                                                zqitem.end }} </a-select-option>

                                                    </a-select>
                                                    <div v-if="leaseData.is_diy == 1">
                                                        <a-date-picker v-model:value="leaseData.zqrangea"
                                                            style="width: 120px" placeholder="租期开始日期"
                                                            :popupStyle="{ 'z-index': 9999 }"
                                                            @change="changzq" />~<a-date-picker
                                                            v-model:value="leaseData.zqrangeb" style="width: 120px"
                                                            placeholder="租期结束日期" :popupStyle="{ 'z-index': 9999 }" />
                                                    </div>
                                                    <a-switch
                                                        v-if="data.user_permission == 'admin' || data.user_permission == 'platform'"
                                                        :checkedValue="1" :unCheckedValue="2"
                                                        v-model:checked="leaseData.is_diy" checked-children="自定义"
                                                        un-checked-children="默认方式"></a-switch>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="理由" required>
                                                    <a-select allow-clear style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择理由" v-model:value="leaseData.reason" required>
                                                        <a-select-option value="仅供银行开户使用"> 仅供银行开户使用 </a-select-option>
                                                        <a-select-option value="其他"> 其他 </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="合同签订日期" required>
                                                    <a-date-picker v-model:value="leaseData.hetong_sign_date"
                                                        style="width: 250px" placeholder="请选择合同签订日期"
                                                        :popupStyle="{ 'z-index': 9999 }" />
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popconfirm>
                                    <a-popconfirm title="催款告知书参数配置" placement="left" @openChange="
                                        (e) => {
                                            openNextYearChange(e, record)
                                        }
                                    " @confirm="downLeaseNextYear(record, item)" v-else-if="item.id == 5">
                                        <template #description>
                                            <a-form style="width: 400px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="渠道联价格" style="width: 300px" required>
                                                    <a-input v-model:value="record.xflxr_xf_price1"
                                                        placeholder="请输入渠道联价格" style="width: 150px" prefix="￥"
                                                        suffix="元">
                                                    </a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="客户联价格" style="width: 300px" required>
                                                    <a-input v-model:value="record.xflxr_xf_price2"
                                                        placeholder="请输入客户联价格" style="width: 150px" prefix="￥"
                                                        suffix="元">
                                                    </a-input>
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popconfirm>
                                    <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                        :cancel-button-props="{ size: 'middle' }" title="确定申报地址异常?" placement="left"
                                        @openChange="
                                            (e) => {
                                                openAnomalyChange(e, record, 2)
                                            }
                                        " @confirm="listed_in_anomaly(record)" v-else-if="item.id == 11">
                                        <template #description>
                                            <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="申报地址异常理由" style="width: 800px" required>
                                                    <a-input v-model:value="record.anomaly_desc" placeholder="请输入理由"
                                                        style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="失联的短信电话截图" style="width: 800px" labelWrap="true">
                                                    <Upload :upload_path="record.upload_path"
                                                        :accept="['png', 'jpg', 'jpeg', 'pdf']"
                                                        uploadType="picture-card" :limitation="99"
                                                        :customerName="record.full_name"
                                                        v-model:value="record.anomaly_url" uploadText="上传失联的短信、电话截图">
                                                    </Upload>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="备注" style="width: 800px">
                                                    <a-input v-model:value="record.anomaly_remark"
                                                        placeholder="请输入备注（可填）" style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item style="width: 800px">
                                                    提示：申报地址异常后还需要递交资料才可以正式列入，请知悉！确定后将自动生成列入异常模板，也可前往档案管理里面再次下载！
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>列入异常资料</p>
                                    </a-popconfirm>
                                    <a-popconfirm title="案件线索移送函参数配置" placement="left" @openChange="
                                        (e) => {
                                            openClueChange(e, record)
                                        }
                                    " @confirm="downLeaseClue(record, item)" v-else-if="item.id == 12">
                                        <template #description>
                                            <a-form style="width: 500px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="投诉举报来源" required>
                                                    <a-select allow-clear style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择投诉举报来源" v-model:value="yisongdata.tsjb_from"
                                                        required>
                                                        <a-select-option value="1"> 湖南市场监管投诉举报平台工单 </a-select-option>
                                                        <a-select-option value="2"> 长沙市12345政务热线工单 </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="店铺名称" required>
                                                    <a-input v-model:value="yisongdata.dp_name" style="width: 250px"
                                                        placeholder="请输入店铺名称"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="销售的产品名称" required>
                                                    <a-input v-model:value="yisongdata.dp_sell_productname"
                                                        style="width: 250px" placeholder="请输入销售的产品名称"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="被投诉产品的订单号" required>
                                                    <a-input v-model:value="yisongdata.dp_sell_productid"
                                                        style="width: 250px" placeholder="请输入被投诉产品的订单号"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="违法违规情况" required>
                                                    <a-select allow-clear style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择违规情况"
                                                        v-model:value="yisongdata.dp_sell_product_wfwgqk" required>
                                                        <a-select-option value="1"> 涉嫌食品安全违法行为 </a-select-option>
                                                        <a-select-option value="2"> 不符合国家强制性标准 </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="移送平台" required>
                                                    <a-select allow-clear @change="ysptchange" style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择移送平台" v-model:value="yisongdata.dp_yspt"
                                                        required>
                                                        <a-select-option value="阿里巴巴"> 阿里巴巴 </a-select-option>
                                                        <a-select-option value="淘宝"> 淘宝 </a-select-option>
                                                        <a-select-option value="抖音"> 抖音 </a-select-option>
                                                        <a-select-option value="拼多多"> 拼多多 </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="移送至市监所名称" required>
                                                    <a-input v-model:value="yisongdata.yssjs_name" style="width: 250px"
                                                        placeholder="移送至市监所名称"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="接到投诉的日期" required>
                                                    <a-date-picker v-model:value="yisongdata.date_jdts"
                                                        style="width: 250px" placeholder="请输入接到投诉的日期"
                                                        :popupStyle="{ 'z-index': 9999 }" />
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="监管部门上门核查日期" required>
                                                    <a-date-picker v-model:value="yisongdata.date_smhc"
                                                        style="width: 250px" placeholder="请输入监管部门上门核查日期"
                                                        :popupStyle="{ 'z-index': 9999 }" />
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popconfirm>
                                    <p v-else @click="downLease(item)">{{ item.name }}</p>
                                </div>
                            </template>
                            <template #content v-if="data.user_permission == 'shixi'">
                                <!-- 实习代理商就下载一个银行开户资料 -->
                                <div v-for="(item, index) in record.DownType" :key="index">
                                    <p v-if="item.id == 3" @click="downLease(item.children[1])">{{
                                        item.name }}</p>
                                    <p v-if="item.id == 1" @click="downLease(item)">{{
                                        item.name }}</p>
                                </div>
                            </template>
                            <a>下载</a>
                        </a-popover>
                        <a-divider type="vertical" />
                        <a @click="handleEdit(record)" v-if="record.permission_show_edit == 1">编辑</a>
                    </template>
                </template>
            </a-table>
            <!-- 简版 -->
            <a-table size="small" v-else rowClassName="tableRowClass" :columns="columns_simple" :loading="data.loading"
                :data-source="dataSource" :pagination="pagination" @change="onChange">
                <template #bodyCell="{ column, record, index, text }">
                    <template v-if="column.dataIndex === 'companyInformation'">
                        <div class="companyInformation"
                            :style="record.exception_flag == 6 ? { borderLeft: '10px dashed #000' } : {}">
                            <a-tag color="grey" v-if="record.status === 2">该主体已注销</a-tag>
                            <a-tag color="grey" v-if="record.status === 3">该主体已吊销</a-tag>
                            <a-tag color="grey" v-if="record.status === 4">该主体已迁走</a-tag>
                            <a-popconfirm title="确定【撤销已迁走】?" @confirm="cancel_delete_zhuti(record.id, 4)">
                                <a v-if="record.status === 4">撤销已迁走</a>
                            </a-popconfirm>
                            <a-tag color="grey" v-if="record.status === 7">主体迁走审核中...</a-tag>
                            <a-popconfirm title="确定【撤销迁走审核】?" @confirm="cancel_delete_zhuti(record.id, 1)">
                                <a v-if="record.status === 7">撤销迁走审核</a>
                            </a-popconfirm>
                            <a-tag color="grey" v-if="record.status === 5">该主体已删除</a-tag>
                            <a-popconfirm title="确定【撤销已删除】?" @confirm="cancel_delete_zhuti(record.id, 3)">
                                <a v-if="record.status === 5">撤销已删除</a>
                            </a-popconfirm>
                            <a-tag v-if="record.status === 6" color="grey"> 主体删除审核中...</a-tag>
                            <a-popconfirm title="确定【撤销删除审核】?" @confirm="cancel_delete_zhuti(record.id, 2)">
                                <a v-if="record.status === 6">撤销删除审核</a>
                            </a-popconfirm>
                            <div>
                                <a-popover trigger="click" v-model:open="record.isShowCompany"
                                    overlayClassName="customer-options-popover">
                                    <template #content>
                                        <p @click="handleDoubleNameClick(record.tyc_url)">跳转到天眼查</p>
                                        <p @click="handleDoubleNameClick(record.qcc_url)">跳转到企查查</p>
                                        <p
                                            @click="handleCopyClick(record.full_name + '的办理服务大厅网址为：' + record.fwzx_url + '，大厅可自助查看进度、下载营业执照、章程、银行开户资料，也可自助邮寄哦！！！请勿转发给直接客户，自行查阅即可！！！')">
                                            复制服务中心网址
                                        </p>
                                    </template>
                                    <div style="width: 100%"></div>
                                </a-popover>
                                <span class="mr-1x pointer"
                                    :style="record.status === 5 ? { textDecorationLine: 'line-through', fontSize: '14px' } : { fontSize: '14px' }"
                                    @click="
                                        (e) => {
                                            record.isShowCompany = false
                                            handleNameClick(e, record.full_name)
                                        }
                                    " @dblclick="
                                        () => {
                                            record.isShowCompany = true
                                        }
                                    " v-html="record.fullName"></span>【{{ record.userPositionList[0].usrename[0] }}】
                                <a><a-badge-ribbon
                                        v-if="record.activity_info.activity && record.activity_info.status == 1"
                                        @click="showActivityDetail(record)" text="参加活动的订单" color="red">
                                    </a-badge-ribbon></a>
                                <a v-if="record.activity_info.activity && record.activity_info.status == 1"
                                    @click="addQueue(record)"><a-badge-ribbon text="立即排队免单" color="blue"
                                        style="margin-top: 30px">
                                    </a-badge-ribbon></a>
                                <template v-if="record.is_pay == 2">
                                    <template v-if="record.permission_show_pay == 1">
                                        <a-tag class="pointer" color="#f50"
                                            @click="onDirectPaymentClick(record)">未支付</a-tag>
                                    </template>
                                    <template v-else>
                                        <a-tag class="pointer" color="#f50">未支付</a-tag>
                                    </template>
                                </template>
                                <a-tag color="#f50" v-else-if="record.is_pay == 3">待续费</a-tag>
                                <a-tag color="gray" v-else-if="record.is_pay == 4">报损</a-tag>
                                <a-tag color="cyan" v-else-if="record.is_pay == 1">已支付√</a-tag>
                                <a-tag color="orange" v-else>状态未知</a-tag>
                                <a-tag color="green" v-if="record.business_type == 2">同区迁入</a-tag>
                                <a-tag color="green" v-if="record.business_type == 3">跨区迁入</a-tag>
                                <a-tag color="green" v-if="record.fee_standard == 2">一次性付费</a-tag>
                                <a-tag color="green" v-if="record.registration_type == 2">裸地址</a-tag>
                                <a-tag class="pointer" color="#87d068" defaultBg="red"
                                    v-if="record.CustomerRefundOrder">
                                    <a-popover trigger="click" overlayClassName="customer-options-popover">
                                        <template #content>
                                            退款状态：<span style="color: orange"
                                                v-if="record.CustomerRefundOrder?.status == 0">退款待审核</span>
                                            <span v-if="record.CustomerRefundOrder?.status == 2">退款已驳回</span>
                                            <span v-if="record.CustomerRefundOrder?.status == 3">退款已撤销</span>
                                            <span style="color: green"
                                                v-if="record.CustomerRefundOrder?.status == 1">退款成功</span>
                                            <br />
                                            退款编号：{{ record.CustomerRefundOrder?.order_number }}
                                            <br />
                                            退款理由：{{ record.CustomerRefundOrder?.refund_remark }}
                                            <br />
                                            申请时间：{{ record.CustomerRefundOrder?.created_at }}
                                            <br />
                                            <div v-if="record.CustomerRefundOrder?.status == 1">
                                                退款时间：{{ record.CustomerRefundOrder?.updated_at }}
                                                <br />
                                                退款金额：{{ record.CustomerRefundOrder?.reality_refund_amount }}
                                            </div>
                                        </template>
                                        <span>有退款记录</span>
                                    </a-popover>
                                </a-tag>
                                <a-tag color="blue" v-else-if="record.mailing_type == 2">自动邮寄√</a-tag>
                                <a-tag color="blue" v-if="record.licenAcceptType == 2">工商局邮寄</a-tag>
                                <!-- 宽寓大厦可以领章 -->
                                <a-tag color="blue" class="pointer"
                                    v-if="record.issong_seal == 1 && record.business_type == 1 && record.main_type != 2"
                                    @click="freeZhang(record)">点击领章</a-tag>
                                <a-popover placement="right" :overlayInnerStyle="{
                                    padding: '25px'
                                }">
                                    <template #content>
                                        <a-watermark
                                            :content="'信息确认单 ' + (record.seller || record.ludan_person?.nickname || '')"
                                            :gap="[150, 150]" fontWeight="light">
                                            <div style="font-size: 16px; font-weight: 550; border-bottom: 1px dotted #ccc; padding-bottom: 8px"
                                                @click="copydetailinfo(record)">
                                                主体名称: {{ record.full_name
                                                }}<a-tag style="font-weight: normal"
                                                    :color="['非正常户注销', '注销'].includes(record.tax_status_name) ? 'red' : 'green'"
                                                    v-if="record.tax_status">{{ record.tax_status_name }} 税务状态更新时间：{{
                                                        record.tax_check_time }}
                                                    <span v-if="record.tax_type == 2">一般人认定时间：{{ record.tax_ybr_time
                                                    }}</span>
                                                </a-tag>
                                            </div>
                                            <div style="margin: 6px 0">地址：{{ record.full_address_number }}</div>
                                            <div style="margin: 6px 0" class="d-flex"
                                                v-if="record.history_names?.length > 0">
                                                <div>历史申请：</div>
                                                <div>
                                                    <div v-for="(item, index) in record.history_names" :key="index">
                                                        {{ item }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="margin: 6px 0" v-if="record.social_credit_code?.length > 0">
                                                统一社会信用代码：{{ record.social_credit_code }}</div>
                                            <div style="margin: 6px 0">
                                                <span class="mr-2x">入驻时间：{{ record.enter_starttime.substr(0, 10) }}
                                                    <span class="mv-1x">~</span> {{ record.enter_endtime.substr(0, 10)
                                                    }}
                                                    <span
                                                        v-if="enterTime(record.enter_endtime) && record.fee_standard == 1"
                                                        class="red">（{{ enterTime(record.enter_endtime) }}）</span>
                                                    <a-tag color="green">{{ record.fee_standard == 1 ? '按年续费' :
                                                        record.fee_standard == 2 ? '一次性付费' : '未知付费方式' }}</a-tag>
                                                </span>
                                                <span class="mr-2x" v-if="record.tyc_update_time">
                                                    <SyncOutlined style="color: #1677ff" /> {{ record.tyc_update_time
                                                    }}更新
                                                </span>
                                            </div>
                                            <div style="margin: 6px 0">
                                                <span v-if="record.verify_time" class="mr-2x">核准日期：{{
                                                    record.verify_time.substr(0, 10) }} </span>
                                                <span v-if="record.founding_time" class="mr-2x"> 成立日期：{{
                                                    record.founding_time.substr(0, 10) }} </span>
                                                <span v-if="record.created_at"> 录入系统时间：{{ record.created_at }} </span>
                                            </div>
                                            <div style="margin: 6px 0">
                                                <p class="mr-2x">
                                                    工商预留手机号码：<span style="color: red">{{ record.registration_mobile
                                                    }}</span>
                                                </p>
                                            </div>
                                            <div style="margin: 6px 0; max-width: 800px">
                                                <span class="mr-2x">经营范围：<span v-html="record.businessScope"></span>
                                                </span>
                                            </div>
                                            <div style="margin: 16px 0">
                                                <a-table :columns="shareholderColumns" size="small" rowKey="name"
                                                    :pagination="false" :data-source="record.shareholder_list">
                                                    <template #bodyCell="res">
                                                        <template v-if="res.column.dataIndex == 'name'">
                                                            <div>
                                                                <div class="tablewraptr">
                                                                    {{ res.text }}
                                                                    <a-tag
                                                                        :color="res.record.hehuo_type == 1 ? 'blue' : 'green'"
                                                                        v-if="record.main_type == 4 && (res.record.type == 2 || res.record.is_shareholder == 1)">{{
                                                                            res.record.hehuo_type == 1 ? '有限合伙人' : '普通合伙人'
                                                                        }}</a-tag><span class='onekeylimited'>
                                                                        <a-popconfirm v-if="user.id == 1"
                                                                            :title="`您确定将'${res.record.name}'限制入驻吗?`"
                                                                            placement="top" " @confirm="
                                                                                onekeylimit(res.record)">
                                                                            <a>限制入驻</a></a-popconfirm>
                                                                    </span>
                                                                </div>
                                                                <div v-if="res.record.phone_number">工商预留电话{{
                                                                    res.record.phone_number }}
                                                                </div>
                                                                <div v-if="record.permission_look_gd_tel == 1"><span
                                                                        v-if="res.record.phone_number_fengkong">风控电话</span>{{
                                                                            res.record.phone_number_fengkong }}
                                                                </div>
                                                                <div v-if="record.id_card_number">
                                                                    <a v-if="res.record.id_card_number_show == 1"
                                                                        @click="idCardNumberClick(res.record, 0)">
                                                                        {{ res.record.id_card_number }}
                                                                        <EyeInvisibleOutlined />
                                                                    </a>
                                                                    <a v-else @click="idCardNumberClick(res.record, 1)">
                                                                        {{ res.record.id_card_number.substr(0, 3) +
                                                                            '********' +
                                                                            res.record.id_card_number.substr(15) }}
                                                                        <EyeOutlined />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <template v-if="res.column.dataIndex == 'address'">
                                                            <div>{{ res.record.address }}</div>
                                                            <div v-if="res.record.type == 1">
                                                                <a-button v-if="res.record.showidcard"
                                                                    @click="res.record.showidcard = 0"
                                                                    style="display: block; padding: 0"
                                                                    type="link">查看身份证照片1</a-button>
                                                            </div>
                                                            <div v-if="res.record.type == 2">
                                                                <a-button v-if="res.record.showidcard"
                                                                    @click="res.record.showidcard = 0"
                                                                    style="display: block; padding: 0"
                                                                    type="link">查看营业执照照片</a-button>
                                                            </div>
                                                            <div v-if="!res.record.showidcard && res.record.type == 1">
                                                                <b-image :width="100"
                                                                    :src="$store.state.user.image_domain + res.record.id_card_back"></b-image>
                                                                <b-image :width="100"
                                                                    :src="$store.state.user.image_domain + res.record.id_card_front"></b-image>
                                                            </div>
                                                            <div v-if="!res.record.showidcard && res.record.type == 2">
                                                                <b-image :width="100"
                                                                    :src="$store.state.user.image_domain + res.record.business_license_url"></b-image>
                                                            </div>
                                                        </template>
                                                        <template v-if="res.column.dataIndex == 'position_name'">
                                                            <div v-if="record.main_type == 1" style="max-width: 230px">
                                                                <div v-if="res.text">
                                                                    <span v-for="(item, index) in res.text.split(',')"
                                                                        :key="index">
                                                                        <a-tag v-if="item?.length > 0" color="cyan">{{
                                                                            record.is_filiale == 1 ?
                                                                                item.replace(/法定代表人/g, '负责人') : item
                                                                        }}</a-tag>
                                                                    </span>
                                                                </div>
                                                                <div v-else>-</div>
                                                            </div>
                                                            <div v-else-if="record.main_type == 4"
                                                                style="max-width: 230px">
                                                                <div v-if="res.text">
                                                                    <span
                                                                        v-for="(item, index) in res.text.replace('法定代表人', '执行事务合伙人').split(',')"
                                                                        :key="index">
                                                                        <a-tag v-if="item?.length > 0" color="cyan">{{
                                                                            item
                                                                        }}</a-tag>
                                                                    </span>
                                                                </div>
                                                                <div v-else>-</div>
                                                            </div>
                                                            <div v-else>
                                                                <a-tag color="cyan">负责人</a-tag>
                                                            </div>
                                                        </template>
                                                        <template v-if="res.column.dataIndex == 'investment_money'">
                                                            <div v-if="res.record.is_shareholder == 1">{{ res.text
                                                            }}<span v-if="res.text">万元</span>
                                                            </div>
                                                            <div v-else>-</div>
                                                        </template>
                                                        <template v-if="res.column.dataIndex == 'subscribe_endtime'">
                                                            <div
                                                                v-if="(record.main_type == 1 || record.main_type == 4) && res.record.is_shareholder == 1">
                                                                {{ res.text?.substr(0, 10) }}
                                                            </div>
                                                            <div v-else>-</div>
                                                        </template>
                                                    </template>
                                                </a-table>
                                            </div>
                                        </a-watermark>
                                    </template>
                                    <a type="primary" style="margin-left: 10px">更多1</a>
                                </a-popover>
                            </div>
                            <div style="margin-bottom: 8px" v-if="record.taglist">
                                <a-tag :color="item.color" v-for="(item, index) in record.taglist" :key="index">{{
                                    item.name
                                }}</a-tag>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'status'">
                        <div v-if="record.customer_work_order_status">
                            <p class="mb-x">
                                <a-badge color="#87d068"
                                    v-if="record.customer_work_order_status.after_status_name == '已办结'"
                                    status="success" />
                                <a-badge color="#108ee9" v-else status="processing" />
                                <template v-if="
                                    record.permission_show_status == 2 &&
                                    (record.customer_work_order_status?.after_status_name == '做单中' ||
                                        record.customer_work_order_status?.after_status_name == '待签名' ||
                                        record.customer_work_order_status?.after_status_name == '材料检查中' ||
                                        record.customer_work_order_status?.after_status_name == '有问题待协商停止录单')
                                ">
                                    已录单</template>
                                <template v-else-if="data.user_permission == 'shixi'">
                                    <!-- 1003是公司的材料检查中，7080是待签名。实习代理商的这两个状态推迟15分钟 -->
                                    <span v-if="
                                        ((record.customer_work_order_status?.after_status == '1003' && record.main_type != 2) || (record.customer_work_order_status?.after_status == '7080' && record.main_type == 2)) &&
                                        dayjs().diff(dayjs(record.customer_work_order_status?.created_at), 'minute') < 15 &&
                                        record.platform_id != 18 &&
                                        record.platform_id != 23 &&
                                        ![64, 226, 97, 86, 532].includes(user.id)
                                    ">
                                        交资料中，请稍等
                                    </span>
                                    <span v-else>{{ record.customer_work_order_status?.after_status_name }}
                                        <p
                                            v-if="record.customer_work_order_status?.after_status == '1004' || record.customer_work_order_status?.after_status == '7005'">
                                            {{ record.customer_work_order_status.reason }}
                                        </p>
                                        <p style="font-size: 12px; border: 1px dashed #ccc; padding: 5px; color: rgb(177 80 80)"
                                            v-if="record.customer_work_order_status.beizhu">
                                            {{ record.customer_work_order_status?.beizhu }}
                                        </p>
                                    </span>
                                </template>

                                <template v-else>
                                    {{ record.customer_work_order_status?.after_status_name }}
                                </template>
                                <a-popconfirm title="确定推送主体当前状态给续费联系人及销售?" @confirm="handleTuiS(record)"
                                    v-if="data.user_permission == 'admin'">
                                    <a v-if="record.customer_work_order_status?.after_status_name && record.customer_work_order_status?.after_status_name != '已办结'"
                                        class="ml-1x">推送</a>
                                </a-popconfirm>

                                <a class="ml-1x"
                                    v-if="record.customer_work_order_status?.after_status == 2 || record.customer_work_order_status?.after_status == 3"
                                    @click="cancelPushOrder(record)">撤销通知做单</a>
                            </p>
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'price'">
                        <text v-if="record.fee_standard == 1 && record.registration_type == 1">
                            {{ record.dls_bzc_price }}
                        </text>
                        <text v-if="record.fee_standard == 1 && record.registration_type == 2">
                            {{ record.dls_luo_price }}
                        </text>
                        <text v-if="record.fee_standard == 2">
                            {{ record.dls_ycx_price }}
                        </text>
                        /
                        <text>{{ record.xflxr_zc_price }}</text>
                    </template>
                    <template v-else-if="column.dataIndex === 'xftel'">
                        <div class="changerole">
                            <div v-hasUser="[record.seller_id, record.ludan_id]">
                                <p class="mb-x">
                                    <a-popover placement="left" :overlayInnerStyle="{
                                        padding: '25px'
                                    }">
                                        <template #content>
                                            <div
                                                style="font-size: 16px; font-weight: 550; border-bottom: 1px dotted #ccc; padding-bottom: 8px">
                                                渠道详细情况：</div>
                                            <div style="width: 450px; line-height: 26px">
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">工商预留手机号码：</a-col>
                                                    <a-col :span="14">{{ record.registration_mobile }}<a
                                                            @click="handleCopyClick(record.registration_mobile)"
                                                            class="ml-1x">
                                                            <CopyOutlined />
                                                        </a></a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">续费联系人手机号码：</a-col>
                                                    <a-col :span="14">
                                                        <div v-if="record.isEditXftel">
                                                            <a-input style="width: 130px; margin-bottom: 5px"
                                                                v-model:value="record.new_xftel" @change="
                                                                    (v) => {
                                                                        phoneChange(v, 'new_xftel', record)
                                                                    }
                                                                " name="new_xftel" placeholder="请输入手机号码"></a-input>
                                                            <div>
                                                                <a-button class="mr-2x" @click="
                                                                    () => {
                                                                        record.isEditXftel = false
                                                                    }
                                                                " size="small">取消</a-button>
                                                                <a-button @click="editPhoneChange(record)" size="small"
                                                                    type="primary">确认</a-button>
                                                            </div>
                                                        </div>
                                                        <span v-else @click="
                                                            () => {
                                                                record.new_xftel = record.xftel
                                                                record.isEditXftel = true
                                                            }
                                                        " class="pointer phone_number">{{ record.xftel
                                                            || '无' }}
                                                            <EditTwoTone />
                                                        </span>
                                                    </a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司名称：</a-col>
                                                    <a-col :span="14">{{ record.finance_company_name }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司统一社会信用代码：</a-col>
                                                    <a-col :span="14">{{ record.finance_social_credit_code }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司对接人姓名：</a-col>
                                                    <a-col :span="14">{{ record.finance_contact_name }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司对接人其他号码：</a-col>
                                                    <a-col :span="14">{{ record.finance_contact_phone }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司对接人微信昵称：</a-col>
                                                    <a-col :span="14"><a-avatar size="small"
                                                            :src="record.xf_person?.headimgurl"
                                                            v-if="!!record.finance_contact_wechat_nickname">
                                                            <template #icon>
                                                                <UserOutlined />
                                                            </template> </a-avatar>{{
                                                                record.finance_contact_wechat_nickname }}</a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">财务公司对接人微信号：</a-col>
                                                    <a-col :span="14">{{ record.finance_contact_wechat_account
                                                    }}<a v-if="!!record.finance_contact_wechat_account"
                                                            @click="handleCopyClick(record.finance_contact_wechat_account)"
                                                            class="ml-1x">
                                                            <CopyOutlined />
                                                        </a></a-col>
                                                </a-row>
                                                <a-row>
                                                    <a-col :span="10" style="text-align: right">备注：</a-col>
                                                    <a-col :span="14">{{ record.remark }}</a-col>
                                                </a-row>
                                            </div>
                                        </template>
                                        续费人：<a-avatar :size="18" :src="record.xf_person?.headimgurl">
                                            <template #icon>
                                                <UserOutlined />
                                            </template>
                                        </a-avatar>
                                    </a-popover>

                                    {{ record.xf_person?.nickname }}
                                    <span v-if="!record.xf_person">未关注公众号<a-image :width="18"
                                            src="https://hncs.cskaiyela.com/wxewm.jpg" /></span>
                                    <a @click="handleCopyClick(record.xftel)" class="ml-1x"
                                        v-hasUser="[record.seller_id, record.ludan_id]">
                                        <CopyOutlined />
                                    </a>
                                </p>
                            </div>
                        </div>
                    </template>
                    <template v-else-if="column.dataIndex === 'action'">
                        <a-popover @openChange="
                            (val) => {
                                optionsVisibleChange(val, record)
                            }
                        " trigger="click" v-model:open="record.isShowOptions"
                            overlayClassName="customer-options-popover">
                            <template #content>
                                <p @click="onActionClick(record, 'PayCenter')" v-if="record.permission_show_pay == 1">
                                    支付中心
                                </p>
                                <p @click="onActionClick(record, 'Invoice')">发票申请
                                </p>

                                <!-- <a-popconfirm
                  title="确定录入?"
                  placement="left"
                  @openChange="
                    (e) => {
                      openShouru(e, record)
                    }
                  "
                  @confirm="handleShouru(record)"
                >
                  <template #description>
                    <a-form style="width: 600px" v-bind="formLayout">
                      <a-form-item label="收入事项">
                        <a-input v-model:value="revenue.income_event_text" placeholder="请输入收入事项"> </a-input>
                      </a-form-item>
                      <a-form-item label="收入">
                        <a-input type="number" addon-after="元" v-model:value="revenue.income" placeholder="请输入收入"> </a-input>
                      </a-form-item>
                      <a-form-item label="销售员">
                        <a-input v-model:value="revenue.salesman" placeholder="请输入销售员"> </a-input>
                      </a-form-item>
                      <a-form-item label="收款人">
                        <a-input v-model:value="revenue.payee" placeholder="请输入收款人"> </a-input>
                      </a-form-item>
                      <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="相关附件(选填)">
                        <Upload :upload_path="record.upload_path" :accept="['png', 'jpg', 'jpeg', 'pdf']" uploadType="text" :limitation="1" v-model:value="revenue.annex_url" uploadText="上传附件">
                        </Upload>
                      </a-form-item>
                    </a-form>
                  </template>
<p>录入收入</p>
</a-popconfirm> -->

                                <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                    :cancel-button-props="{ size: 'middle' }" title="属性调整控制台" placement="left"
                                    @openChange="
                                        (e) => {
                                            openAttrChange(e, record)
                                        }
                                    " @confirm="submitAttrAdjust(record)">
                                    <template #description>
                                        <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout"
                                            ref="attrformRef">
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="属性名称"
                                                required>
                                                <a-select allow-clear style="width: 250px"
                                                    :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                    placeholder="请选择待调整的属性名称" v-model:value="customer_attr.name"
                                                    required>
                                                    <a-select-option value="fee_standard"> 收费标准 </a-select-option>
                                                    <a-select-option value="dls_xf_price"> 续费价格（{{
                                                        record.seller }}拿货价） </a-select-option>
                                                    <a-select-option value="enter_starttime"> 入驻开始日期 </a-select-option>
                                                    <a-select-option value="enter_endtime"> 入驻到期日期 </a-select-option>
                                                    <a-select-option value="founding_time"> 成立日期 </a-select-option>
                                                    <a-select-option value="verify_time"> 核准日期 </a-select-option>
                                                    <a-select-option value="yifang_name"> 租房合同乙方姓名 </a-select-option>
                                                </a-select>
                                            </a-form-item>
                                            <div v-if="customer_attr.name == 'fee_standard'">
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整前值" required>
                                                    <a-radio-group v-model:value="customer_attr.old_fee_standard"
                                                        button-style="solid">
                                                        <a-radio-button :value="1"
                                                            v-if="record.fee_standard == 1">按年收费</a-radio-button>
                                                        <a-radio-button :value="2"
                                                            v-if="record.fee_standard == 2">一次性收费</a-radio-button>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整后值" required>
                                                    <a-radio-group v-model:value="customer_attr.fee_standard"
                                                        button-style="solid">
                                                        <a-radio-button :value="1"
                                                            v-if="record.fee_standard == 2">按年收费</a-radio-button>
                                                        <a-radio-button :value="2"
                                                            v-if="record.fee_standard == 1">一次性收费</a-radio-button>
                                                    </a-radio-group>
                                                </a-form-item>
                                            </div>
                                            <div v-else-if="customer_attr.name == 'dls_xf_price'">
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整前值" required> ￥{{ record.dls_xf_price }} </a-form-item>
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整后值" required>
                                                    <a-input v-model:value="customer_attr.dls_xf_price" prefix="￥"
                                                        suffix="元" style="width: 250px" placeholder="请输入续费价格"></a-input>
                                                </a-form-item>
                                            </div>
                                            <div v-else-if="customer_attr.name == 'enter_starttime'">
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整前值" required> {{ record.enter_starttime }} </a-form-item>
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整后值" required>
                                                    <a-date-picker v-model:value="customer_attr.enter_starttime"
                                                        placeholder="选择入驻开始日期"
                                                        :popupStyle="{ 'z-index': 9999 }"></a-date-picker>
                                                </a-form-item>
                                            </div>

                                            <div v-else-if="customer_attr.name == 'enter_endtime'">
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整前值" required> {{ record.enter_endtime }} </a-form-item>
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整后值" required>
                                                    <a-date-picker v-model:value="customer_attr.enter_endtime"
                                                        placeholder="选择入驻结束日期"
                                                        :popupStyle="{ 'z-index': 9999 }"></a-date-picker>
                                                </a-form-item>
                                            </div>
                                            <div v-else-if="customer_attr.name == 'founding_time'">
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整前值" required> {{ record.founding_time }} </a-form-item>
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整后值" required>
                                                    <a-date-picker v-model:value="customer_attr.founding_time"
                                                        placeholder="选择成立日期"
                                                        :popupStyle="{ 'z-index': 9999 }"></a-date-picker>
                                                </a-form-item>
                                            </div>
                                            <div v-else-if="customer_attr.name == 'verify_time'">
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整前值" required> {{ record.verify_time }} </a-form-item>
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整后值" required>
                                                    <a-date-picker v-model:value="customer_attr.verify_time"
                                                        placeholder="选择核准日期"
                                                        :popupStyle="{ 'z-index': 9999 }"></a-date-picker>
                                                </a-form-item>
                                            </div>
                                            <div v-else-if="customer_attr.name == 'yifang_name'">
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整前值" required> {{ record.yifang_name }} </a-form-item>
                                                <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                    label="调整后值" required>
                                                    <a-input v-model:value="customer_attr.yifang_name"
                                                        style="width: 250px" placeholder="请输入乙方名称"></a-input>
                                                </a-form-item>
                                            </div>

                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }" label="调整理由"
                                                required name="remark">
                                                <a-input v-model:value="customer_attr.remark" style="width: 250px"
                                                    placeholder="调整理由"></a-input>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 7 }" :wrapperCol="{ span: 17 }"
                                                label="相关附件(选填)" name="template_url">
                                                <Upload :upload_path="record.upload_path + '属性调整/'" uploadType="text"
                                                    :accept="['pdf', 'doc', 'docx', 'xls', 'xlsx', 'jpeg', 'jpg', 'png']"
                                                    :limitation="1" v-model:value="customer_attr.annex_url"
                                                    uploadText="上传附件">
                                                </Upload>
                                            </a-form-item>
                                        </a-form>
                                    </template>
                                    <p>属性调整</p>
                                </a-popconfirm>
                                <p @click="onActionClick(record, 'Refund')">退款</p>
                                <!-- <p v-if="record.is_pay != 2 && record.fee_standard != 2" @click="onActionClick(record, 'PayCenter')">地址续费</p> -->
                                <PushCustPaid :tableColumnsData="record" v-if="data.user_permission != 'shixi'">
                                    <p>推送至微信收款</p>
                                </PushCustPaid>
                                <!-- <p v-if="!record.first_pay_time" @click="onDirectPaymentClick(record)">支付第一次入驻服务费</p> -->
                                <a-popover trigger="click" overlayClassName="customer-options-popover"
                                    v-if="data.user_permission != 'shixi'">
                                    <template #content>
                                        <p @click="onTaxInquiryClick(record, 1)">税务基础情况查询</p>
                                        <p @click="onTaxInquiryClick(record, 2)">一般纳税人查询</p>
                                        <p @click="onTaxInquiryClick(record, 3)">税务登记基本信息查询</p>
                                    </template>
                                    <p>税务查询</p>
                                </a-popover>
                                <p @click="onActionClick(record, 'AddTable')" v-if="data.user_permission != 'shixi'">
                                    标签管理
                                </p>
                                <p @click="onActionClick(record, 'SFMail')" v-if="record.permission_show_edit == 1">发快递
                                </p>
                                <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                    :cancel-button-props="{ size: 'middle' }" title="确定锁定不列入异常?" placement="left"
                                    @openChange="
                                        (e) => {
                                            openLockExceptionChange(e, record)
                                        }
                                    " @confirm="submitLockException(record)" v-if="data.user_permission != 'shixi'">
                                    <template #description>
                                        <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout">
                                            <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }" label="锁定理由"
                                                style="width: 800px" required>
                                                <a-input v-model:value="lockException.reason" placeholder="请输入理由"
                                                    style="width: 320px"> </a-input>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                label="锁定起止时间" style="width: 800px" required>
                                                <div class="d-flex">
                                                    <a-range-picker :show-time="{ defaultValue: arrayMonent }"
                                                        :popupStyle="{ 'z-index': 9999 }" :value="lockRangTime"
                                                        @change="lockRangTimeChange" :format="format"></a-range-picker>
                                                </div>
                                            </a-form-item>

                                            <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                label="锁定理由图片" style="width: 800px" labelWrap="true">
                                                <Upload :upload_path="record.upload_path"
                                                    :accept="['png', 'jpg', 'jpeg', 'pdf']" uploadType="picture-card"
                                                    :limitation="99" :customerName="record.full_name"
                                                    v-model:value="lockException.url" uploadText="上传锁定理由图片">
                                                </Upload>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }" label="备注"
                                                style="width: 800px">
                                                <a-input v-model:value="lockException.remark" placeholder="请输入备注（可填）"
                                                    style="width: 320px"> </a-input>
                                            </a-form-item>
                                            <a-form-item style="width: 800px"> 提示：锁定后无法列入异常。 </a-form-item>
                                        </a-form>
                                    </template>
                                    <p>申请锁定不列异常</p>
                                </a-popconfirm>
                                <ChangeExceptionflag :customerData="record" @change="(exception_flag, endtime) => {
                                    change_exception_flag(exception_flag, endtime, record)
                                }" v-if="data.user_permission != 'shixi'"
                                    @update:loading="val => { data.loading = val; }">
                                    <p>调整异常状态</p>
                                </ChangeExceptionflag>
                                <a-popconfirm title="确定申报地址异常?" placement="left" @openChange="
                                    (e) => {
                                        openAnomalyChange(e, record, 1)
                                    }
                                " @confirm="listed_in_anomaly(record)" v-if="data.user_permission != 'shixi'"
                                    ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                    :cancel-button-props="{ size: 'middle' }">
                                    <template #description>
                                        <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout">
                                            <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                label="申报地址异常理由" style="width: 800px" required>
                                                <a-input v-model:value="record.anomaly_desc" placeholder="请输入理由"
                                                    style="width: 320px"> </a-input>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                label="失联的短信电话截图" style="width: 800px" labelWrap="true">
                                                <Upload :upload_path="record.upload_path"
                                                    :accept="['png', 'jpg', 'jpeg', 'pdf']" uploadType="picture-card"
                                                    :limitation="99" :customerName="record.full_name"
                                                    v-model:value="record.anomaly_url" uploadText="上传失联的短信、电话截图">
                                                </Upload>
                                            </a-form-item>
                                            <a-form-item label="操作" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                style="width: 800px" required>
                                                <a-radio-group v-model:value="record.doaction_type">
                                                    <a-radio :value="1"> 直接列入(上工单，外勤会直接去送材料，谨慎操作) </a-radio><br />
                                                    <a-radio :value="2"> 仅下载列入异常申报资料 </a-radio>
                                                </a-radio-group>
                                            </a-form-item>
                                            <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }" label="备注"
                                                style="width: 800px">
                                                <a-input v-model:value="record.anomaly_remark" placeholder="请输入备注（可填）"
                                                    style="width: 320px"> </a-input>
                                            </a-form-item>
                                            <a-form-item style="width: 800px">
                                                提示：申报地址异常后还需要递交资料才可以正式列入，请知悉！确定后将自动生成列入异常模板，也可前往档案管理里面再次下载！
                                            </a-form-item>
                                        </a-form>
                                    </template>
                                    <p>申报地址异常</p>
                                </a-popconfirm>
                                <p @click="oneKeyKezhang(record)">一键刻章</p>
                                <p @click="onCopyClick(record)">复制</p>
                                <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                    :cancel-button-props="{ size: 'middle' }" title="确定删除?" placement="left"
                                    @openChange="
                                        (e) => {
                                            openDeleteChange(e, record)
                                        }
                                    " @confirm="handleDelete(record)">
                                    <template #description>
                                        <a-form style="width: 600px" v-bind="formLayout">
                                            <a-form-item label="删除原因" required>
                                                <a-radio-group v-model:value="record.deleteType">
                                                    <a-radio :value="1">废弃</a-radio>
                                                    <a-radio :value="2">该主体已注销</a-radio>
                                                    <a-radio :value="3">该主体已迁出</a-radio>
                                                    <a-radio :value="4">报损</a-radio>
                                                </a-radio-group>
                                            </a-form-item>
                                            <a-form-item label="理由" required v-if="record.deleteType == 1">
                                                <a-input v-model:value="record.desc" placeholder="请输入理由"> </a-input>
                                            </a-form-item>
                                            <a-form-item label="理由" v-else>
                                                <a-input v-model:value="record.desc" placeholder="请输入理由"> </a-input>
                                            </a-form-item>
                                            <a-form-item label="备注"> 删除后可在主体回收站中撤回删除 </a-form-item>
                                        </a-form>
                                    </template>
                                    <p>删除</p>
                                </a-popconfirm>
                            </template>

                            <a @click="
                                () => {
                                    record.isShowOptions = true
                                }
                            ">更多</a>
                        </a-popover>
                        <a-divider type="vertical" />
                        <a @click="onActionClick(record, 'Record')">档案</a>
                        <a-divider type="vertical" />
                        <a-popover trigger="click" overlayClassName="customer-options-popover">
                            <template #content v-if="data.user_permission != 'shixi'">
                                <div v-for="(item, index) in record.DownType" :key="index">
                                    <a-popover trigger="click" overlayClassName="customer-options-popover"
                                        v-if="item.children?.length > 0" placement="left">
                                        <template #content>
                                            <div v-for="(downLeaseItem, downLeaseIndex) in item.children"
                                                :key="downLeaseIndex" @click="downLease(downLeaseItem)">
                                                <div v-if="downLeaseItem.children?.length > 0">
                                                    {{ downLeaseItem.name }}
                                                </div>
                                                <p v-else>
                                                    {{ downLeaseItem.name }}
                                                </p>
                                                <div v-if="downLeaseItem.children?.length > 0">
                                                    <p v-for="(downItem, downIndex) in downLeaseItem.children"
                                                        :key="downIndex" @click="downLease(downItem)">
                                                        {{ downItem.name }}
                                                    </p>
                                                </div>
                                            </div>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popover>
                                    <a-popconfirm v-else-if="item.id == 4" title="租赁合同" placement="left" @openChange="
                                        (e) => {
                                            openLeaseChange(e, record)
                                        }
                                    " @confirm="downLeaseLease(record, item)">
                                        <template #description>
                                            <a-form style="width: 400px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="是否盖公章" required>
                                                    <a-radio-group v-model:value="leaseData.gz" @change="changeLeaseGz">
                                                        <a-radio :value="1"> 有公章 </a-radio>
                                                        <a-radio :value="2"> 无公章 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="是否签字" required>
                                                    <a-radio-group v-model:value="leaseData.qz">
                                                        <a-radio :value="2"> 无签字 </a-radio>
                                                        <a-radio :value="1" v-if="leaseData.gz == 1"> 有签字 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="合同租金是否遮挡" required>
                                                    <a-radio-group v-model:value="leaseData.zd">
                                                        <a-radio :value="1"> 遮挡 </a-radio>
                                                        <a-radio :value="2"> 未遮挡 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="租金" v-if="leaseData.zd == 2" required>
                                                    <a-input v-model:value="leaseData.zujin" placeholder="请输入合同价格"
                                                        style="width: 150px" prefix="￥" suffix="元"> </a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="入驻类型" required>
                                                    <a-radio-group v-model:value="leaseData.fee_standard">
                                                        <a-radio :value="1"> 按年收费 </a-radio>
                                                        <a-radio :value="2"> 一次性收费 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="是否显示电话" required>
                                                    <a-radio-group v-model:value="leaseData.tel">
                                                        <a-radio :value="2"> 不显示 </a-radio>
                                                        <a-radio :value="1"> 显示 </a-radio>
                                                    </a-radio-group>
                                                </a-form-item>

                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="租期" required>
                                                    <a-select allow-clear v-if="leaseData.is_diy != 1"
                                                        style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择租期" v-model:value="leaseData.zqrange" required
                                                        @change="changzq">
                                                        <a-select-option :value="zqitem.start + '~' + zqitem.end"
                                                            v-for="zqitem in record.zqlist">
                                                            {{
                                                                zqitem.start }}~{{
                                                                zqitem.end }} </a-select-option>

                                                    </a-select>
                                                    <div v-if="leaseData.is_diy == 1">
                                                        <a-date-picker v-model:value="leaseData.zqrangea"
                                                            style="width: 120px" placeholder="请选择合同签订日期"
                                                            :popupStyle="{ 'z-index': 9999 }"
                                                            @change="changzq" />~<a-date-picker
                                                            v-model:value="leaseData.zqrangeb" style="width: 120px"
                                                            placeholder="请选择合同签订日期" :popupStyle="{ 'z-index': 9999 }" />
                                                    </div>
                                                    <a-switch
                                                        v-if="data.user_permission == 'admin' || data.user_permission == 'platform'"
                                                        :checkedValue="1" :unCheckedValue="2"
                                                        v-model:checked="leaseData.is_diy" checked-children="自定义"
                                                        un-checked-children="默认方式"></a-switch>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="理由" required>
                                                    <a-select allow-clear style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择理由" v-model:value="leaseData.reason" required>
                                                        <a-select-option value="仅供银行开户使用"> 仅供银行开户使用 </a-select-option>
                                                        <a-select-option value="其他"> 其他 </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="合同签订日期" required>
                                                    <a-date-picker v-model:value="leaseData.hetong_sign_date"
                                                        style="width: 250px" placeholder="请选择合同签订日期"
                                                        :popupStyle="{ 'z-index': 9999 }" />
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popconfirm>
                                    <a-popconfirm title="催款告知书参数配置" placement="left" @openChange="
                                        (e) => {
                                            openNextYearChange(e, record)
                                        }
                                    " @confirm="downLeaseNextYear(record, item)" v-else-if="item.id == 5">
                                        <template #description>
                                            <a-form style="width: 400px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="渠道联价格" style="width: 300px" required>
                                                    <a-input v-model:value="record.xflxr_xf_price1"
                                                        placeholder="请输入渠道联价格" style="width: 150px" prefix="￥"
                                                        suffix="元">
                                                    </a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="客户联价格" style="width: 300px" required>
                                                    <a-input v-model:value="record.xflxr_xf_price2"
                                                        placeholder="请输入客户联价格" style="width: 150px" prefix="￥"
                                                        suffix="元">
                                                    </a-input>
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popconfirm>
                                    <a-popconfirm ok-text="确定" cancel-text="取消" :ok-button-props="{ size: 'middle' }"
                                        :cancel-button-props="{ size: 'middle' }" title="确定申报地址异常?" placement="left"
                                        @openChange="
                                            (e) => {
                                                openAnomalyChange(e, record, 2)
                                            }
                                        " @confirm="listed_in_anomaly(record)" v-else-if="item.id == 11">
                                        <template #description>
                                            <a-form style="width: 600px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="申报地址异常理由" style="width: 800px" required>
                                                    <a-input v-model:value="record.anomaly_desc" placeholder="请输入理由"
                                                        style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="失联的短信电话截图" style="width: 800px" labelWrap="true">
                                                    <Upload :upload_path="record.upload_path"
                                                        :accept="['png', 'jpg', 'jpeg', 'pdf']"
                                                        uploadType="picture-card" :limitation="99"
                                                        :customerName="record.full_name"
                                                        v-model:value="record.anomaly_url" uploadText="上传失联的短信、电话截图">
                                                    </Upload>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }"
                                                    label="备注" style="width: 800px">
                                                    <a-input v-model:value="record.anomaly_remark"
                                                        placeholder="请输入备注（可填）" style="width: 320px"> </a-input>
                                                </a-form-item>
                                                <a-form-item style="width: 800px">
                                                    提示：申报地址异常后还需要递交资料才可以正式列入，请知悉！确定后将自动生成列入异常模板，也可前往档案管理里面再次下载！
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>列入异常资料</p>
                                    </a-popconfirm>
                                    <a-popconfirm title="案件线索移送函参数配置" placement="left" @openChange="
                                        (e) => {
                                            openClueChange(e, record)
                                        }
                                    " @confirm="downLeaseClue(record, item)" v-else-if="item.id == 12">
                                        <template #description>
                                            <a-form style="width: 500px; margin-top: 30px" v-bind="formLayout">
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="投诉举报来源" required>
                                                    <a-select allow-clear style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择投诉举报来源" v-model:value="yisongdata.tsjb_from"
                                                        required>
                                                        <a-select-option value="1"> 湖南市场监管投诉举报平台工单 </a-select-option>
                                                        <a-select-option value="2"> 长沙市12345政务热线工单 </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="店铺名称" required>
                                                    <a-input v-model:value="yisongdata.dp_name" style="width: 250px"
                                                        placeholder="请输入店铺名称"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="销售的产品名称" required>
                                                    <a-input v-model:value="yisongdata.dp_sell_productname"
                                                        style="width: 250px" placeholder="请输入销售的产品名称"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="被投诉产品的订单号" required>
                                                    <a-input v-model:value="yisongdata.dp_sell_productid"
                                                        style="width: 250px" placeholder="请输入被投诉产品的订单号"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="违法违规情况" required>
                                                    <a-select allow-clear style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择违规情况"
                                                        v-model:value="yisongdata.dp_sell_product_wfwgqk" required>
                                                        <a-select-option value="1"> 涉嫌食品安全违法行为 </a-select-option>
                                                        <a-select-option value="2"> 不符合国家强制性标准 </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="移送平台" required>
                                                    <a-select allow-clear @change="ysptchange" style="width: 250px"
                                                        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                                                        placeholder="请选择移送平台" v-model:value="yisongdata.dp_yspt"
                                                        required>
                                                        <a-select-option value="阿里巴巴"> 阿里巴巴 </a-select-option>
                                                        <a-select-option value="淘宝"> 淘宝 </a-select-option>
                                                        <a-select-option value="抖音"> 抖音 </a-select-option>
                                                        <a-select-option value="拼多多"> 拼多多 </a-select-option>
                                                    </a-select>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="移送至市监所名称" required>
                                                    <a-input v-model:value="yisongdata.yssjs_name" style="width: 250px"
                                                        placeholder="移送至市监所名称"></a-input>
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="接到投诉的日期" required>
                                                    <a-date-picker v-model:value="yisongdata.date_jdts"
                                                        style="width: 250px" placeholder="请输入接到投诉的日期"
                                                        :popupStyle="{ 'z-index': 9999 }" />
                                                </a-form-item>
                                                <a-form-item :labelCol="{ span: 8 }" :wrapperCol="{ span: 16 }"
                                                    label="监管部门上门核查日期" required>
                                                    <a-date-picker v-model:value="yisongdata.date_smhc"
                                                        style="width: 250px" placeholder="请输入监管部门上门核查日期"
                                                        :popupStyle="{ 'z-index': 9999 }" />
                                                </a-form-item>
                                            </a-form>
                                        </template>
                                        <p>{{ item.name }}</p>
                                    </a-popconfirm>
                                    <p v-else @click="downLease(item)">{{ item.name }}</p>
                                </div>
                            </template>
                            <template #content v-if="data.user_permission == 'shixi'">
                                <!-- 实习代理商就下载一个银行开户资料 -->
                                <div v-for="(item, index) in record.DownType" :key="index">
                                    <p v-if="item.id == 3" @click="downLease(item.children[1])">{{
                                        item.name }}</p>
                                    <p v-if="item.id == 1" @click="downLease(item)">{{
                                        item.name }}</p>
                                </div>
                            </template>
                            <a>下载</a>
                        </a-popover>
                        <a-divider type="vertical" />
                        <a @click="handleEdit(record)" v-if="record.permission_show_edit == 1">编辑</a>
                    </template>
                </template>
            </a-table>
        </div>
        <ExceptionTaizhang v-if="data.showtype == 2" ref="taizhangRef" :queryParam="queryParam"></ExceptionTaizhang>
        <!-- 新增客户 -->
        <create-form ref="createForm" :key="data.createKey" :open="data.visible" @cancel="handleCancel" @ok="handleOk"
            @noticeDoAction="noticeDoAction" />
        <edit-form v-if="data.editVisible" :open="true" :tableColumnsData="data.tableColumnsData" @cancel="handleCancel"
            @ok="handleOk" />
        <CopyForm v-if="data.copyVisible" :open="true" :tableColumnsData="data.tableColumnsData" @cancel="handleCancel"
            @ok="handleOk" @noticeDoAction="noticeDoAction" />
        <Refund v-if="data.refundVisible" :tableColumnsData="data.tableColumnsData" @cancel="handleCancel"
            @ok="handleOk" />

        <!-- 查看日志 -->
        <view-log :logTabsKey="data.logTabsKey" v-if="data.visibleLog" :tableColumnsData="data.tableColumnsData"
            @cancel="viewLogCancel"></view-log>
        <!-- 直接付款 -->
        <direct-payment v-if="data.directPaymentVisible" @cancel="handleCancel" @ok="handleOk"
            :tableColumnsData="data.tableColumnsData"></direct-payment>

        <InvoiceApply v-if="data.invoiceVisible" @cancel="handleCancel" @ok="handleOk"
            :tableColumnsData="data.tableColumnsData"></InvoiceApply>
        <XftelTixian v-if="data.xfteltixianVisible" @cancel="handleCancel" @ok="handleOk"
            :tableColumnsData="data.tableColumnsData"></XftelTixian>

        <WXInformDrawer></WXInformDrawer>

        <!-- 推送做单 -->
        <push-order-making :tableColumnsData="data.tableColumnsData" v-if="data.pushOrderMakingVisible"
            @cancel="handleCancel" @ok="handleOk"></push-order-making>

        <!-- 查看签名状态 -->
        <SignatureStatus :tableColumnsData="data.tableColumnsData" v-if="data.signatureStatusVisible" @cancel="
            () => {
                data.signatureStatusVisible = false
            }
        "></SignatureStatus>

        <s-f-mail :tableColumnsData="data.tableColumnsData" v-if="data.SFMailVisible" @cancel="handleCancel"
            @ok="handleOk"></s-f-mail>
        <PayCenter :tableColumnsData="data.tableColumnsData" v-if="data.addressRenewVisible" @cancel="handleCancel"
            @ok="handleOk"></PayCenter>
        <AddLabel :tableColumnsData="data.tableColumnsData" v-if="data.addTableVisible" @cancel="
            () => {
                data.addTableVisible = false
            }
        "></AddLabel>
        <Record :tableColumnsData="data.tableColumnsData" v-if="data.recordVisible" @cancel="
            () => {
                data.recordVisible = false
            }
        "></Record>
        <!-- 一键刻章 -->
        <CreateKezhang v-if="kezhangData.visible" :open="true" :customerData="kezhangData.customerData"
            @cancel="handleCancel" @ok="handleKezhangOk"></CreateKezhang>
        <!-- 一键刻章-微信扫码支付 -->
        <KezhangPayment v-if="kezhangData.directPaymentVisible" @cancel="handlePayOk" @ok="handlePayOk"
            :kezhangId="kezhangData.directPaymentId"></KezhangPayment>
        <!-- 免费领章信息 -->
        <FreeZhang v-if="freeZhangData.visible" :open="true" :customerData="freeZhangData.customerData"
            @cancel="freeZhangCancel" @ok="freeZhangCancel"></FreeZhang>
        <!--
        <entry-agreement :tableColumnsData="data.tableColumnsData" v-if="data.entryAgreementVisible" @cancel="() => {
            data.entryAgreementVisible = false
        }
            "></entry-agreement> -->
        <!-- 上传地址资料 -->
        <UploadDzzl :tableColumnsData="data.dzzlData" v-if="data.dzzlVisible" @cancel="handleCancel" @ok="handleOk">
        </UploadDzzl>
        <!-- 完善代理商信息 -->
        <RealNameHalf v-if="data.showWanshan" @cancel="handleCancel" @ok="handleRnOk" :userId="user.id">
        </RealNameHalf>
        <!-- 活动的详情 -->
        <a-modal v-model:open="activityDetail.activityDetailVisible" :title="'活动详情：'" @ok="activityDetailCancel"
            width="60%">
            <div v-html="activityDetail.activityDetail" style="padding: 20px"></div>
        </a-modal>
        <!-- 异常日志 -->
        <YichangLog v-if="yichangLog.visible" :detailData="yichangLog" @cancel="handYichangLogCancel"
            @ok="handYichangLogCancel">
        </YichangLog>
        <!-- 支付邮费 -->
        <PlatformBalanceCharge v-if="data.payLogisticsVisible" @cancel="handleCancel" @ok="handleOk"
            :logisticsCustomerId="data.tableColumnsData.id ?? ''">
        </PlatformBalanceCharge>
    </a-card>
</template>

<script lang="ts" setup name="CustomerList">
import { UserOutlined, SearchOutlined, DeleteOutlined, SyncOutlined, EditOutlined, CheckOutlined, NotificationOutlined, UploadOutlined, PhoneOutlined } from '@ant-design/icons-vue'
import SvgIcon from '@/components/SvgIcon/index.vue'
import { PlusOutlined, DownOutlined, UpOutlined, CopyOutlined, EditTwoTone, DeleteTwoTone, WechatOutlined, ThunderboltOutlined, EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons-vue'
import type { PaginationProps } from 'ant-design-vue'
import CreateForm from './CreateForm.vue'
import CopyForm from './CreateForm.vue'
import EditForm from './EditForm.vue'
import Refund from './components/Refund.vue'
import Record from './components/Record.vue'
import Upload from '@/components/base/Upload.vue'
import ViewLog from './components/ViewLog.vue'
import UploadDzzl from './components/UploadDzzl.vue'
import PushOrderMaking from './components/PushOrderMaking.vue'
import SignatureStatus from './components/SignatureStatus.vue'
import PayCenter from './components/PayCenter.vue'
import DirectPayment from './components/DirectPayment.vue'
import InvoiceApply from './components/InvoiceApply.vue'
import XftelTixian from './components/XftelTixian.vue'
import SFMail from './components/SFMail.vue'
import AddLabel from './components/addLabel.vue'
import WXInformDrawer from './WXInformDrawer/index.vue'
import CreateKezhang from './../kezhangManagement/components/CreateKezhang.vue'
import KezhangPayment from './../kezhangManagement/components/DirectPayment.vue'
import RealNameHalf from '../system/components/RealNameHalf.vue'
import FreeZhang from './components/FreeZhang.vue'
import PlatformPick from '@/components/base/PlatformPick.vue'
import ChangeExceptionflag from './components/ChangeExceptionflag.vue'
import ExceptionTaizhang from './components/ExceptionTaizhang.vue'
import YichangLog from './components/YichangLog.vue'
import PlatformBalanceCharge from './../financialManagement/components/PlatformBalanceCharge.vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { ref, reactive, h, onMounted, computed, onActivated, watch, nextTick } from 'vue'
import dayjs from 'dayjs'
import ls from '@/utils/Storage'
import { mobileRequiredValidator } from '@/utils/util'
import PushCustPaid from './components/PushCustPaid.vue'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const token = ls.get('ACCESS_TOKEN').replace('Bearer ', '')
import { useStore } from 'vuex'
import { loginSuccess } from './../user/helper'
import { fnExportFields } from './customerFn'
import BImage from '@/components/sourceImg/BImage.vue'
import BFile from '@/components/sourceImg/BFile.vue'
import { state } from '@antv/g2plot/lib/adaptor/common'
const $store = useStore()
const user = ls.get('USER_INFO')
const router = useRouter()
const format = 'YYYY-MM-DD HH:mm:ss'
const shareholderColumns: Object[] = [
    {
        title: '姓名、身份标识、手机号码',
        dataIndex: 'name'
    },
    {
        title: '照片',
        dataIndex: 'address',
        width: 200
    },
    {
        title: '职位',
        dataIndex: 'position_name'
    },
    {
        title: '出资金额',
        dataIndex: 'investment_money'
    },
    {
        title: '认缴出资日期',
        dataIndex: 'subscribe_endtime'
    }
]

interface data {
    key: string | number
    rowSelection: number[]
    customerNavig: any
    entryAgreementVisible: boolean
    recordVisible: boolean
    addTableVisible: boolean
    signatureStatusVisible: boolean
    directPaymentVisible: boolean
    invoiceVisible: boolean
    xfteltixianVisible: boolean
    pushOrderMakingVisible: boolean
    SFMailVisible: boolean
    addressRenewVisible: boolean
    visibleLog: boolean
    visibleStatus: boolean
    optionsVisible: boolean
    visible: boolean
    advanced: boolean
    tableColumnsData: Object
    loading: boolean
    editVisible: boolean
    copyVisible: boolean
    refundVisible: boolean
    exportLoading_dc: boolean
    exportLoading_gx: boolean
    exportLoading_delete: boolean
    logTabsKey: number
    createKey: number
    downList: any
    customerInfo: any
    progressOptions: any[]
    tabsKey: number
    chat_read_count: number
    tycupdateVisible: boolean
    taxupdateVisible: boolean
    user_permission: string
    dzzlData: any
    dzzlVisible: boolean
    showWanshan: boolean
    noticeDoActionId: number
    list_simple: number
    updatetype: number
    exception_remark: string
    showtype: number,
    download_sbException_loading: boolean,
    tabsExceptionKey: number,
    exception_url: any[],
    payLogisticsVisible: boolean
}
const data = reactive<data>({
    key: '',
    rowSelection: [],
    customerNavig: {},
    exportLoading_dc: false,
    exportLoading_gx: false,
    exportLoading_delete: false,
    // 入驻协议
    entryAgreementVisible: false,
    // 档案管理
    recordVisible: false,
    // 打标签
    addTableVisible: false,
    // 查看签名状态
    signatureStatusVisible: false,
    // 付款弹窗
    directPaymentVisible: false,
    invoiceVisible: false,
    xfteltixianVisible: false,
    // 推送做单
    pushOrderMakingVisible: false,
    // 顺丰邮寄
    SFMailVisible: false,
    //   地址续费
    addressRenewVisible: false,
    visibleLog: false,
    visibleStatus: false,
    // 操作弹窗
    optionsVisible: false,
    // create model
    visible: false,
    // 高级搜索 展开/关闭
    advanced: false,
    tableColumnsData: {},
    loading: false,
    // 编辑
    editVisible: false,
    copyVisible: false,
    refundVisible: false,
    // 进入日志 还是进入状态
    logTabsKey: 1,
    createKey: 1,
    /* 下载列表 */
    downList: {},
    //数据列表
    customerInfo: {},
    // 进度状态
    progressOptions: [],
    tabsKey: 1,
    chat_read_count: 0,
    tycupdateVisible: false,
    taxupdateVisible: false,
    user_permission: 'shixi', //用户权限admin,platform,seller,shixi实习代理商
    dzzlData: {},
    dzzlVisible: false,
    showWanshan: false, //完善代理商信息
    noticeDoActionId: 0,
    list_simple: 2,
    updatetype: 2,
    tabsExceptionKey: 2,
    showtype: 1,
    download_sbException_loading: false,
    exception_remark: '',
    exception_url: [],
    payLogisticsVisible: false
})
const yisongdata = reactive({
    curent_id: 0,
    tsjb_from: '1',
    dp_name: '',
    dp_sell_productname: '',
    dp_sell_productid: '',
    dp_sell_product_wfwgqk: '',
    dp_yspt: '',
    yssjs_name: '',
    date_jdts: '',
    date_smhc: ''
})
const nameOrCodeChange = () => {
    //将(替换成（
    queryParam.nameOrCode = queryParam.nameOrCode.replace(/\(/g, '（')
    //将)替换成）
    queryParam.nameOrCode = queryParam.nameOrCode.replace(/\)/g, '）')
}
const ysptchange = () => {
    yisongdata.yssjs_name =
        yisongdata.dp_yspt == '阿里巴巴'
            ? '杭州市高新区（滨江）市场监督管理局'
            : yisongdata.dp_yspt == '淘宝'
                ? '杭州市余杭区市场监督管理局'
                : yisongdata.dp_yspt == '抖音'
                    ? '上海市杨浦区市场监督管理局'
                    : yisongdata.dp_yspt == '拼多多'
                        ? '长宁区市场监督管理局'
                        : ''
}

const filteredInfo = ref()
const createForm = ref()

const columns = computed(() => {
    const filtered = filteredInfo.value || []
    const progressOptions = data.progressOptions
    return [
        {
            title: '公司名称',
            dataIndex: 'companyInformation',
            width: 350
        },
        {
            title: '当前状态',
            dataIndex: 'status',
            filters: progressOptions,
            filteredValue: filtered || null,
            width: 220
        },
        {
            title: '地址',
            dataIndex: 'full_address_number',
            width: 220
        },
        {
            title: '其他信息',
            dataIndex: 'seller',
            width: 240
        },
        {
            title: '操作',
            dataIndex: 'action',
            width: 200
        }
    ]
})
const columns_simple = computed(() => {
    const filtered = filteredInfo.value || []
    const progressOptions = data.progressOptions
    return [
        {
            title: '公司名称',
            dataIndex: 'companyInformation'
        },
        {
            title: '当前状态',
            dataIndex: 'status',
            filters: progressOptions,
            filteredValue: filtered || null
        },

        {
            title: '录入时间',
            dataIndex: 'created_at'
        },
        {
            title: '拿货价/销售价',
            dataIndex: 'price'
        },
        {
            title: '续费电话',
            dataIndex: 'xftel'
        },
        {
            title: '操作',
            dataIndex: 'action',
            width: 200
        }
    ]
})
const formLayout = {
    labelCol: {
        xs: { span: 4 },
        sm: { span: 4 }
    },
    wrapperCol: {
        xs: { span: 16 },
        sm: { span: 16 }
    }
}
let queryParam = reactive<any>({
    order_status_list: ['blz'],
    tabsKey: data.tabsKey
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
    pageSize: 10,
    pageSizeOptions: ['10', '20', '50', '100', '200', '400'],
    current: 1,
    total: undefined,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total) => `总数：${total}`
})
onMounted(() => {
    customerNavig()
    let changerole_search = localStorage.getItem('changerole_search')
    let changerole_tabkey = localStorage.getItem('changerole_tabkey')
    if (changerole_search) {
        localStorage.removeItem('changerole_search')
        let old_query_param = JSON.parse(changerole_search)
        if (old_query_param) {
            queryParam.nameOrCode = old_query_param.nameOrCode
            queryParam.fr_name = old_query_param.fr_name
            queryParam.xftel = old_query_param.xftel
        }

        data.tabsKey = Number(changerole_tabkey) || 2
        tabsChange(data.tabsKey)
    } else {
        //如果是平台管理员则默认是3所有办理中
        const hasRole = $store.state.permission.addRoles.some((role) => {
            return 'platform' == role || 'shopmanager' == role || 'root' == role
        })
        if (hasRole) {
            data.tabsKey = 3
            tabsChange(data.tabsKey)
        }
    }
    loadData()
})
onActivated(() => {
    if (router.currentRoute?.value?.query?.customer_name) {
        queryParam.nameOrCode = router.currentRoute.value.query.customer_name
        if (data.tabsKey == 1 || data.tabsKey == 3) {
            data.tabsKey = data.tabsKey + 1
            queryParam.order_status_list = []
        }
        loadData()
    }
})
// 跳转天眼查
const handleDoubleNameClick = (url) => {
    window.open(url)
}
// 时间选择
const rangTime = computed(() => {
    let array: any = []
    if (queryParam.between_time) {
        array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
// 时间选择
const rangTimeChange = (val, str) => {
    if (val) {
        queryParam.between_time = str.join(',')
    } else {
        queryParam.between_time = null
    }
}

// 复制
const handleCopyClick = (val) => {
    var input = document.createElement('input')
    //将input的值设置为需要复制的内容
    input.value = val
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功!')
    //移除input标签
    document.body.removeChild(input)
}
// 复制名称
const handleNameClick = (e, name) => {
    if (e.detail == 1) {
        var input = document.createElement('input')
        //将input的值设置为需要复制的内容
        input.value = name
        //添加input标签
        document.body.appendChild(input)
        //选中input标签
        input.select()
        //执行复制
        document.execCommand('copy')
        //成功提示信息
        message.success('复制成功，尝试双击有惊喜！')
        //移除input标签
        document.body.removeChild(input)
    }
}
const handleTuiS = (record) => {
    const hide = message.loading({
        content: '推送中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/pushWechatMessage?customer_id=' + record.id,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            setTimeout(hide, 500)
            message.success(res.msg ? res.msg : '推送成功')
        })
        .catch((res) => {
            setTimeout(hide, 500)
            message.error(res.msg ? res.msg : '推送失败')
        })
}
const phoneChange = (v, type, record) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    record[type] = str
}
//该表做单快捷备注
const change_order_preparation_mode = (record) => {
    record.is_auto = record.is_auto == 1 ? 2 : 1
    let requestParam = {
        url: '/admin/v1/change_order_preparation_mode',
        method: 'post',
        data: {
            customer_id: record.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg ? res.msg : '推送成功')
        })
        .catch((res) => {
            message.error(res.msg ? res.msg : '推送失败')
        })
}

const handleTuiSYBJ = (record) => {
    const hide = message.loading({
        content: '推送中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/addWorkOrderLogbj',
        method: 'post',
        data: {
            customer_id: record.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            setTimeout(hide, 500)
            loadData()
            message.success(res.msg ? res.msg : '推送成功')
        })
        .catch((res) => {
            setTimeout(hide, 500)
            message.error(res.msg ? res.msg : '推送失败')
        })
}

const cancel_delete_zhuti = (id, type) => {
    const hide = message.loading({
        content: '操作中,请稍等...',
        duration: 0,
        class: 'loading-message'
    })
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customer/cancel_delete_zhuti',
        method: 'post',
        data: {
            customer_id: id,
            type: type
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            setTimeout(hide, 500)
            message.success(res.msg ? res.msg : '操作成功')
            loadData()
        })
        .catch((res) => {
            setTimeout(hide, 500)
            message.error(res.msg ? res.msg : '操作失败')
        })
}

// 进度状态选择
const tabsChange = (val) => {
    data.tabsKey = val
    queryParam.tabsKey = val
    data.showtype = 1
    if (val == 1 || val == 3) {
        queryParam.order_status_list = ['blz']
        queryParam.order_status = undefined
        queryParam.exception_flag = []
        loadData()
    } else if (val == 6) {
        //待申报地址异常
        queryParam.exception_flag = [2]
        queryParam.order_status_list = []
        //只要不是1未录电子化,2资料待修改,3其他资料待审核
        queryParam.order_status = 102
        loadData()
    } else {
        let order_status_list_tmp = queryParam.order_status_list
        queryParam.order_status_list = order_status_list_tmp
        queryParam.order_status = undefined
        queryParam.exception_flag = []
        refreshTabel()
    }
}
// 进度状态选择
const tabsExceptionKeyChange = (val) => {
    queryParam.exception_flag = [val]
    if (val == 6) {
        //直接只显示台账
        data.showtype = 2
        loadtaizhang()
    } else {
        data.showtype = 1
        loadData()
    }
}
// 获取台账数据
const taizhangRef = ref()
const loadtaizhang = () => {
    if (data.showtype == 1) {
        loadData()
        return
    } else {
        queryParam.showtype = 2
        //加载子组件数据
        nextTick(() => {
            taizhangRef.value.loadData()
        })
    }
}
// 进度状态选择
const orderStatusChange = (val) => {
    if (!val || val.length === 0) {
        data.tabsKey = 1
    }
}
// 进度状态选择
const orderStatusSelect = (val) => {
    if (val == 'blz') {
        queryParam.order_status_list = ['blz']
        data.tabsKey = 1
    } else {
        queryParam.order_status_list = queryParam.order_status_list.filter((item) => item != 'blz')
        //如果是平台管理员则默认是4所有客户
        const hasRole = $store.state.permission.addRoles.some((role) => {
            return 'platform' == role || 'shopmanager' == role || 'root' == role
        })
        if (hasRole) {
            data.tabsKey = 4
        } else {
            data.tabsKey = 2
        }
    }
}
const orderStatusDeselect = (val) => {
    if (val == 'blz') {
        queryParam.order_status_list = []
        data.tabsKey = 1
    } else {
        queryParam.order_status_list = queryParam.order_status_list.filter((item) => item != 'blz')
        //如果是平台管理员则默认是4所有客户
        const hasRole = $store.state.permission.addRoles.some((role) => {
            return 'platform' == role || 'shopmanager' == role || 'root' == role
        })
        if (hasRole) {
            data.tabsKey = 4
        } else {
            data.tabsKey = 2
        }
    }
}
watch(
    () => queryParam.order_status_list,
    (val) => {
        filteredInfo.value = queryParam.order_status_list
    },
    {
        deep: true,
        immediate: true
    }
)
// 重置刷新
const refreshTabel = () => {
    pagination.current = 1
    if (data.tabsKey == 1 || data.tabsKey == 3) {
        queryParam.order_status_list = ['blz']
    } else {
        queryParam.order_status_list = []
    }
    loadData()
}
// 统计状态切换
const onStisticsClick = (val) => {
    if (queryParam.order_status == val) {
        queryParam.order_status = undefined
        loadData()
        return
    }
    if (val == 3) {
        router.push({ path: '/verification' })
    } else if (val == 5) {
        router.push({ path: '/workOrder' })
    } else if (val == 6) {
        router.push({ path: '/customer/pigeonhole' })
    } else if (val == 8) {
        queryParam.downzc = 1
        queryParam.order_status = undefined
        queryParam.order_status_list = undefined
        loadData()
    } else {
        data.tabsKey = user.id == 1 || data.customerNavig.superPlatformAdminIds ? 4 : 2
        queryParam.tabsKey = data.tabsKey
        queryParam.order_status = val
        queryParam.order_status_list = undefined
        queryParam.downzc = undefined
        loadData()
    }
}
const customer_attr = reactive({
    name: '',
    old_fee_standard: 1,
    fee_standard: 2,
    dls_xf_price: '',
    remark: '',
    annex_url: [],
    enter_starttime: '',
    enter_endtime: '',
    founding_time: '',
    verify_time: '',
    yifang_name: '',
})
const formatDuration = (duration: number) => {
    const days: any = Math.floor(duration / (24 * 60 * 60))
    if (days > 0 && days <= 30) {
        return '到期前30天内'
    } else if (days > 30 && days <= 60) {
        return '到期前60天内'
    } else if (days < 0 && days >= -30) {
        return '到期后30天内'
    } else if (days < -30 && days >= -60) {
        return '到期后60天内'
    } else if (days < -60 && days >= -90) {
        return '到期后90天内'
    } else if (days < -90) {
        return '到期90天后客户,即将申报工商地址异常'
    } else {
        return null
    }
}
const enterTime = (endtime) => {
    const start = dayjs(endtime)
    const end = dayjs()
    const duration = start.diff(end, 'second')
    return formatDuration(duration)
}
// 列表数据
const loadData = () => {
    if (data.loading) {
        return
    }
    data.loading = true
    $store.dispatch('indexPop/checkIndexPop')//全局温馨提示
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customerList',
        method: 'post',
        data: Object.assign({ page: pagination.current, limit: pagination.pageSize }, queryParam)
    }
    baseService(requestParam)
        .then((res) => {
            data.loading = false
            pagination.total = res.data.total_records
            data.customerInfo = {
                unrecorded_electronic: res.data.unrecorded_electronic,
                modify_data: res.data.modify_data,
                to_be_verified: res.data.to_be_verified
            }
            let bsl = queryParam.business_scope_like ? queryParam.business_scope_like.split('#') : []
            dataSource.value = res.data.list.map((item) => {
                if (queryParam.nameOrCode) {
                    item.fullName = item.full_name.replace(queryParam.nameOrCode, `<span style="color: red">${queryParam.nameOrCode}</span>`)
                } else {
                    item.fullName = item.full_name
                }
                if (bsl.length > 0) {
                    for (const b of bsl) {
                        item.businessScope = item.business_scope.replace(b, `<span style="color: red">${b}</span>`)
                    }
                } else {
                    item.businessScope = item.business_scope
                }
                //租赁合同的租期，从入驻开始，到当前租期的下一个租期
                let zqlist: Array<{ start: string; end: string }> = []
                zqlist.push({
                    start: dayjs(item.enter_starttime).add(1, 'year').format('YYYY-MM-DD'),
                    end: dayjs(item.enter_starttime).add(2, 'year').format('YYYY-MM-DD'),
                })
                zqlist.push({
                    start: dayjs(item.enter_starttime).format('YYYY-MM-DD'),
                    end: dayjs(item.enter_starttime).add(1, 'year').format('YYYY-MM-DD'),
                })
                let startday = dayjs(item.created_at).startOf('day')
                let zqend = dayjs(item.enter_starttime)
                while (zqend.isAfter(startday)) {
                    let zqstart = zqend.subtract(1, 'year')
                    if (zqstart.isBefore(startday)) {
                        zqstart = startday
                    }
                    zqlist.push({
                        start: zqstart.format('YYYY-MM-DD'),
                        end: zqend.format('YYYY-MM-DD'),
                    })
                    zqend = zqstart
                }
                zqlist.reverse()


                return { ...item, isShowOptions: false, isShowCompany: false, desc: null, deleteType: null, customer_id: item.id, isEdit: false, zqlist: zqlist }
            })
            let downList: any = []
            for (const key in res.data.down_type) {
                downList.push({ type: key, name: res.data.down_type[key] })
            }
            if (data.progressOptions != res.data.order_status_list) {
                data.progressOptions = res.data.order_status_list
            }
            data.downList = downList
            data.user_permission = res.data.user_permission
            // 如果不是超级管理员或代理商，则导出的字段需要删除
            let exfild = fnExportFields(data.user_permission)
            exportDataArgumentChecked.exportDataArgument = exfild.all
            exportDataArgumentChecked.checkedfieldSimpleBak = exfild.jian
            exportDataArgumentChecked.checkedfieldAll = exfild.quan
            exportDataArgumentChecked.checkedfieldSimple = exfild.jian
            //如果是新增，则弹窗推送做单的框
            if (data.noticeDoActionId > 0) {
                noticeDoActionReal()
                data.noticeDoActionId = 0
            }
        })
        .catch((res) => {
            data.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('客户列表查询失败,请联系管理员')
            }
        })
}
//申报地址异常处理
const openAnomalyChange = (e, record, doaction_type) => {
    record.doaction_type = doaction_type
    record.anomaly_desc = '失联'
    if (!e) {
        record.anomaly_desc = null
        record.anomaly_url = null
        record.anomaly_remark = null
    }
}

//锁定列入异常
const lockException = reactive({
    customer_id: 0,
    reason: '',
    between_time: '',
    url: [],
    remark: ''
})
const openLockExceptionChange = (e, record) => {
    lockException.customer_id = record.id
    lockException.reason = ''
    //默认一个月
    lockException.between_time = dayjs().format(format) + ',' + dayjs().add(1, 'month').format(format)
    lockException.url = []
    lockException.remark = ''
}
const lockRangTimeChange = (val, str) => {
    if (val) {
        lockException.between_time = str.join(',')
    } else {
        lockException.between_time = ''
    }
}
const lockRangTime = computed(() => {
    let array: any = []
    if (lockException.between_time) {
        array = lockException.between_time.split(',').map((item) => dayjs(item ? item : null, format))
    } else {
        array = []
    }
    return array
})
const submitLockException = (record) => {
    lockException.customer_id = record.id
    if (!lockException.between_time) {
        message.warn('请选择时间范围')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (!lockException.reason) {
        message.warn('请填写锁定理由')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    let requestParam = {
        url: '/admin/v1/addLockException',
        method: 'post',
        data: lockException
    }
    baseService(requestParam)
        .then((res) => {
            message.success({
                content: res.msg,
                duration: 10
            })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('锁定失败，请联系管理员')
            }
        })
}

// 切换账号身份
const changerole = (seller) => {
    if (!seller) {
        message.error('未找到用户')
        return
    }
    $store
        .dispatch('SwitchUser', seller)
        .then((res) => {
            $store.dispatch('GetInfo')
            // TODO 默认配置中使用服务端获取菜单
            // if (config.useAsyncRouter) {
            //     generateAsyncRoutes(router, res.menu)
            // }
            loginSuccess(router, res)
            setTimeout(() => {
                if (queryParam.nameOrCode) {
                    localStorage.setItem('changerole_tabkey', data.tabsKey.toString())
                    localStorage.setItem('changerole_search', JSON.stringify(queryParam))
                }
                window.location.href = '/'
            })
        })
        .catch((res) => {
            message.error(res.msg)
        })
}
const listed_in_anomaly = (record) => {
    if (!record.anomaly_desc) {
        message.warn('请输入申报地址异常的理由')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (!record.doaction_type) {
        message.warn('请选择操作类型')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    let requestParam = {
        url: '/admin/v1/listed_in_anomaly',
        method: 'post',
        data: { customer_id: record.id, desc: record.anomaly_desc, url: record.anomaly_url, remark: record.anomaly_remark, doaction_type: record.doaction_type }
    }
    baseService(requestParam)
        .then((res) => {
            record.exception_flag = 2
            message.success({
                content: res.msg,
                duration: 10
            })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('列入异常失败，请联系管理员')
            }
        })
}
//催款告知书
const openNextYearChange = (e, record) => {
    record.xflxr_xf_price1 = record.xflxr_xf_price
    record.xflxr_xf_price2 = record.xflxr_xf_price
}
const downLeaseNextYear = (record, item) => {
    if (!record.xflxr_xf_price1) {
        message.warn('请输入渠道联价格')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (!record.xflxr_xf_price2) {
        message.warn('请输入客户联价格')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    downLease(item, '&xflxr_xf_price1=' + record.xflxr_xf_price1 + '&xflxr_xf_price2=' + record.xflxr_xf_price2)
}
//线索移送函
const openClueChange = (e, record) => {
    if (record.id != yisongdata.curent_id) {
        yisongdata.tsjb_from = '1' //初始化
        yisongdata.dp_name = ''
        yisongdata.dp_sell_productname = ''
        yisongdata.dp_sell_productid = ''
        yisongdata.dp_sell_product_wfwgqk = ''
        yisongdata.dp_yspt = ''
        yisongdata.yssjs_name = ''
        yisongdata.date_jdts = ''
        yisongdata.date_smhc = ''
        yisongdata.curent_id = record.id
    }
}
const downLeaseClue = (record, item) => {
    if (
        !yisongdata.dp_name ||
        !yisongdata.dp_sell_productname ||
        !yisongdata.dp_sell_productid ||
        !yisongdata.dp_sell_product_wfwgqk ||
        !yisongdata.dp_yspt ||
        !yisongdata.yssjs_name ||
        !yisongdata.date_jdts ||
        !yisongdata.date_smhc
    ) {
        message.warn('请检查必填项')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    downLease(
        item,
        '&tsjb_from=' +
        yisongdata.tsjb_from +
        '&dp_name=' +
        yisongdata.dp_name +
        '&dp_sell_productname=' +
        yisongdata.dp_sell_productname +
        '&dp_sell_productid=' +
        yisongdata.dp_sell_productid +
        '&dp_sell_product_wfwgqk=' +
        yisongdata.dp_sell_product_wfwgqk +
        '&dp_yspt=' +
        yisongdata.dp_yspt +
        '&yssjs_name=' +
        yisongdata.yssjs_name +
        '&date_jdts=' +
        yisongdata.date_jdts +
        '&date_smhc=' +
        yisongdata.date_smhc
    )
}

//租赁合同
const leaseData = reactive({
    gz: 2, //公章
    qz: 2, //签字
    zd: 1, //遮挡
    tel: 2, //是否显示电话
    zujin: null, //租金
    zqrange: '', //租期范围
    zqrangea: null, //自定义租期开始
    zqrangeb: null,//自定义租期结束
    is_diy: 2,
    reason: '仅供银行开户使用',
    fee_standard: 1,
    hetong_sign_date: dayjs(dayjs().format('YYYY-MM-DD'), 'YYYY-MM-DD'),
    last_company_id: 0,//切换公司的标记
})
const openLeaseChange = (e, record) => {
    //只切换公司时清空金额，租期，签约日期
    if (leaseData.last_company_id != record.id) {
        leaseData.zujin = record.xflxr_xf_price == 0 ? 300 : record.xflxr_xf_price
        leaseData.zqrange = ''
        leaseData.zqrangea = null
        leaseData.zqrangeb = null
        leaseData.is_diy = 2
        leaseData.hetong_sign_date = dayjs(dayjs().format('YYYY-MM-DD'), 'YYYY-MM-DD')
    }
    // leaseData.gz = 1 //初始化
    // leaseData.qz = 2
    // leaseData.zd = 1
    // leaseData.tel = 2
    // leaseData.fee_standard = record.fee_standard
    // leaseData.zujin = record.xflxr_xf_price == 0 ? 300 : record.xflxr_xf_price
    // leaseData.zqrange = ''
    // leaseData.zqrangea = null
    // leaseData.zqrangeb = null
    // leaseData.is_diy = 2
    // leaseData.reason = '仅供银行开户使用'
    // leaseData.hetong_sign_date = dayjs(dayjs().format('YYYY-MM-DD'), 'YYYY-MM-DD')

    leaseData.last_company_id = record.id
}
const changzq = () => {
    if (leaseData.is_diy == 1) {
        if (leaseData.zqrangea) {
            leaseData.hetong_sign_date = leaseData.zqrangea
        }
    } else {
        let arr = leaseData.zqrange.split('~')
        leaseData.hetong_sign_date = dayjs(arr[0], 'YYYY-MM-DD')
    }
}
const changeLeaseGz = () => {
    if (leaseData.gz == 2) {
        leaseData.qz = 2
    }
}
const downLeaseLease = (record, item) => {
    if (!leaseData.reason) {
        message.warn('请选择理由')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    let zq = ''
    if (leaseData.is_diy == 1) {
        if (!leaseData.zqrangea || !leaseData.zqrangeb) {
            message.warn('请选择租期')
            return new Promise((resolve, reject) => {
                reject()
            })
        }
        zq = dayjs(leaseData.zqrangea).format('YYYY-MM-DD') + '~' + dayjs(leaseData.zqrangeb).format('YYYY-MM-DD')
    } else {
        if (!leaseData.zqrange) {
            message.warn('请选择租期')
            return new Promise((resolve, reject) => {
                reject()
            })
        }
        zq = leaseData.zqrange
    }

    downLease(
        item,
        '&gz=' +
        leaseData.gz +
        '&qz=' +
        leaseData.qz +
        '&zd=' +
        leaseData.zd +
        '&tel=' +
        leaseData.tel +
        '&zujin=' +
        leaseData.zujin +
        '&fee_standard=' +
        leaseData.fee_standard +
        '&zq=' +
        zq +
        '&reason=' +
        leaseData.reason +
        '&hetong_sign_date=' +
        leaseData.hetong_sign_date
    )
}

//属性调整控制台
const openAttrChange = (e, record) => {
    customer_attr.name = ''
    customer_attr.remark = ''
    customer_attr.annex_url = []
    customer_attr.old_fee_standard = record.fee_standard
    if (record.fee_standard == 1) {
        customer_attr.fee_standard = 2
    } else {
        customer_attr.fee_standard = 1
    }
    customer_attr.enter_starttime = ''
    customer_attr.enter_endtime = ''
    customer_attr.founding_time = ''
    customer_attr.verify_time = ''
}
//规则
const attrformRef = ref()
const submitAttrAdjust = (record) => {
    // 阻止默认行为，保持弹窗打开
    return new Promise((resolve, reject) => {
        if (!customer_attr.remark) {
            message.error('请填写调整理由！')
            reject()
        }
        let requestParam = {
            url: '/admin/v1/attrAdjust',
            method: 'post',
            data: {
                customer_id: record.id,
                ...customer_attr
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                message.success({
                    content: res.msg,
                    duration: 10
                })
                resolve(true)
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('提交失败，请稍后重试')
                }
                // 阻止默认行为，保持弹窗打开
                reject(true)
            })
    })
}

//得到地址异常日志
const getExceptionLog = (record, index) => {
    data.visibleLog = true
    record.from = 1
    data.tableColumnsData = { ...record }
    data.logTabsKey = index
}
const customerNavig = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/customerNavig',
        method: 'get'
    }
    baseService(requestParam)
        .then((res) => {
            Object.assign(data.customerNavig, res.data)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取统计失败')
            }
        })
}
// 表格分页查询
const onChange = (val, filters) => {
    pagination.pageSize = val.pageSize
    pagination.current = val.current
    queryParam.order_status_list = filters.status ?? []
    orderStatusSelect(queryParam.order_status_list)
    loadData()
}

const onActionClick = (record, type) => {
    record.isShowOptions = false
    data.tableColumnsData = { ...record }
    switch (type) {
        case 'EntryAgreement':
            data.entryAgreementVisible = true
            break
        case 'SignatureStatus':
            data.signatureStatusVisible = true
            break
        case 'Record':
            data.recordVisible = true
            break
        case 'AddTable':
            data.addTableVisible = true
            break
        case 'SFMail':
            data.SFMailVisible = true
            break
        case 'PayCenter': //地址续费
            data.addressRenewVisible = true
            break
        case 'Invoice': //发票申请
            data.invoiceVisible = true
            break
        case 'XftelTixian': //部分提现(业务来源方提现)
            data.xfteltixianVisible = true
            break
        case 'Refund':
            data.refundVisible = true
            break
    }
}
// 查询日志
const onViewLogClick = (record, val) => {
    record.from = 0
    data.visibleLog = true
    data.tableColumnsData = { ...record }
    data.logTabsKey = val
}

const onDirectPaymentClick = (record) => {
    record.from = undefined
    record.isShowOptions = false
    data.directPaymentVisible = true
    data.tableColumnsData = { ...record }
}
const onUsbphoneClick = (record, phone) => {
    $store.dispatch('usbphone/AddPhoneModal', {
        phone: phone,
        customer_id: record.id,
        full_name: record.full_name
    })
}
const onTaxInquiryClick = (record, type) => {
    let param = `?${record.social_credit_code ? 'data-creditcode=' + record.social_credit_code + '&' : ''}data-companyname=${record.full_name}&type=1`
    if (type == 1) {
        window.open('http://hunan.chinatax.gov.cn/taxpayerstatesearch/20190413003982' + param)
    } else if (type == 2) {
        window.open('http://hunan.chinatax.gov.cn/taxpayersearch/20190413003981' + param)
    } else if (type == 3) {
        window.open('http://hunan.chinatax.gov.cn/taxreginfosearch/20190413003984' + param)
    }
}
const onPushOrderMakingClick = (record) => {
    data.tableColumnsData = { ...record }
    data.pushOrderMakingVisible = true
}

const optionsVisibleChange = (val, record) => {
    if (!val) {
        record.isShowOptions = false
    }
}

const handleAdd = async () => {
    let requestParam = {
        url: '/admin/v1/checkPeriodDays',
        method: 'post',
        data: {}
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.msg == 'nophone') {
                message.error('您的账号没有绑定手机号码，请完善信息后再操作！')
                data.showWanshan = true
                return
            }
            data.tableColumnsData = {}
            data.visible = true
            if (res.msg != 'ok') {
                message.warning(res.msg)
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
const handleRnOk = () => {
    data.showWanshan = false
    handleAdd()
}
const openDeleteChange = (e, record) => {
    if (!e) {
        record.deleteType = null
        record.desc = null
    }
}

const handleDelete = (record) => {
    if (!record.deleteType) {
        message.warn('请选择删除原因')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (!record.desc && user.id != 1) {
        message.warn('请输入删除理由')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    return new Promise((resolve, reject) => {
        let requestParam = {
            url: '/admin/v1/customer/' + record.id,
            method: 'delete',
            data: {
                type: record.deleteType,
                reason: record.desc
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                message.success(res.msg)
                loadData()
                resolve(true)
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
                reject()
            })
    })
}
//批量删除本页
const batchDelete = reactive<any>({
    deleteType: 1,
    desc: '',
    deleteIds: []
})
const openDeleteChangePage = (e) => {
    //批量删除正常应该是要有一个选择框
    batchDelete.deleteIds = []
    dataSource.value.forEach((item) => {
        batchDelete.deleteIds.push((item as any).id)
    })
}
//批量废弃客户
const DeleteCustomerVisible = () => {
    if (!batchDelete.deleteType) {
        message.warn('请选择删除原因')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    if (!batchDelete.desc && user.id != 1) {
        message.warn('请输入删除理由')
        return new Promise((resolve, reject) => {
            reject()
        })
    }
    return new Promise((resolve, reject) => {
        data.exportLoading_delete = true
        let requestParam = {
            url: '/admin/v1/customeBatchDelete',
            method: 'delete',
            data: {
                type: batchDelete.deleteType,
                reason: batchDelete.desc,
                ids: batchDelete.deleteIds
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                data.exportLoading_delete = false
                message.success(res.msg)
                loadData()
                resolve(true)
            })
            .catch((res) => {
                data.exportLoading_delete = false
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
                reject()
            })
    })
}

//更多-录入收入
const revenue = reactive({
    income_event_text: '',
    income: null,
    salesman: '',
    payee: '',
    annex_url: []
})
const openShouru = (e, record) => {
    if (!e) {
        revenue.payee = ''
        revenue.salesman = ''
        revenue.income = null
        revenue.income_event_text = ''
        revenue.annex_url = []
    }
}
const handleShouru = (record) => {
    return new Promise((resolve, reject) => {
        let requestParam = {
            url: '/admin/v1/recordedRevenue/',
            method: 'post',
            data: {
                customer_id: record.id,
                ...revenue
            }
        }
        baseService(requestParam)
            .then((res: any) => {
                message.success(res.msg)
                loadData()
                resolve(true)
            })
            .catch((res) => {
                if (res.msg) {
                    message.error(res.msg)
                } else {
                    message.error('操作失败')
                }
                reject()
            })
    })
}

const onCopyClick = (record) => {
    let requestParam = {
        url: '/admin/v1/checkPeriodDays',
        method: 'post',
        data: {}
    }
    baseService(requestParam)
        .then((res: any) => {
            data.copyVisible = true
            record.isShowOptions = false
            data.tableColumnsData = { ...record, isCopy: true }
            if (res.msg != 'ok') {
                message.warning(res.msg)
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}

const handleEdit = (record) => {
    data.editVisible = true
    data.tableColumnsData = { ...record }
}

const handleOk = () => {
    data.createKey++
    data.pushOrderMakingVisible = false
    data.visible = false
    data.refundVisible = false
    data.editVisible = false
    data.copyVisible = false
    data.addressRenewVisible = false
    data.SFMailVisible = false
    data.directPaymentVisible = false
    data.invoiceVisible = false
    data.xfteltixianVisible = false
    data.dzzlVisible = false
    data.payLogisticsVisible = false
    loadData()
}
const handleCancel = () => {
    data.visible = false
    data.editVisible = false
    data.refundVisible = false
    data.copyVisible = false
    data.pushOrderMakingVisible = false
    data.addressRenewVisible = false
    data.SFMailVisible = false
    data.directPaymentVisible = false
    data.invoiceVisible = false
    data.xfteltixianVisible = false
    kezhangData.visible = false
    data.dzzlVisible = false
    data.showWanshan = false
    data.payLogisticsVisible = false
}
const viewLogCancel = (isRefresh) => {
    if (isRefresh) {
        loadData()
    }
    data.visibleLog = false
}

const downLease = (downItem, attach = '') => {
    if (downItem?.children?.length > 0) {
        return
    }
    let url = downItem.url.replace('https://console.cskaiyela.com/hncskaiyela', '')
    const hide = message.loading({
        content: '等待下载中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: url + attach,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.msg == 'async') {
                const mess = message.success('资料正在准备中，稍后会自动下载，如未自动下载，请前往档案管理处下载！', 0)
                //异步处,根据zipid去查询是否转换完成
                let zipid = res.data
                let down = false //幂等
                let timer = setInterval(() => {
                    let requestParam = {
                        url: '/admin/v1/templateZipWait',
                        method: 'get',
                        params: {
                            id: zipid
                        }
                    }
                    baseService(requestParam).then((res2: any) => {
                        if (res2.msg == 'finish') {
                            //转换完成
                            clearInterval(timer)
                            if (!down) {
                                down = true //幂等
                                //转换完成，直接下载
                                setTimeout(mess, 0)
                                let a = document.createElement('a')
                                let event = new MouseEvent('click')
                                a.download = ''
                                a.href = `/hncskaiyela/admin/v1/templateZipDown?id=${zipid}&token=${token}`
                                a.dispatchEvent(event)
                            }
                        }
                    })
                }, 2000)
                setTimeout(hide, 2000)

                return
            }
            let a = document.createElement('a')
            let event = new MouseEvent('click')
            a.download = ''
            a.href = downItem.url + `&token=${token}&down=1`
            a.dispatchEvent(event)
            setTimeout(hide, 2000)
        })
        .catch((res) => {
            setTimeout(hide, 500)
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
const change_exception_flag = (exception_flag, endtime, record) => {
    record.exception_flag = exception_flag
    if (exception_flag == 2) {
        record.exception_flag_seller_endtime = Date.now() / 1000 + endtime * 60 * 60;
    }
}
//代理商确定待申报异常
const change_exception_seller = (record) => {
    if (!data.exception_remark) {
        message.error('请填写备注')
        return
    }
    let requestParam = {
        url: '/admin/v1/change_anomaly_seller',
        method: 'post',
        data: {
            id: record.id,
            remark: data.exception_remark,
            exception_url: data.exception_url
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
//公司确定待申报异常
const change_exception_fws = (record) => {
    if (!data.exception_remark) {
        message.error('请填写备注')
        return
    }
    data.loading = true
    let requestParam = {
        url: '/admin/v1/change_anomaly_fws',
        method: 'post',
        data: {
            id: record.id,
            remark: data.exception_remark,
            exception_url: data.exception_url
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            data.loading = false
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
const donwloadClick = (type) => {
    let href = 'https://hncs.cskaiyela.com/storage/public/uploads/模版库/芙蓉区通用开户资料.zip'
    let a = document.createElement('a')
    let event = new MouseEvent('click')
    a.download = ''
    a.href = href
    a.dispatchEvent(event)
}
const exportDataArgumentChecked = reactive({
    visible: false,
    companylist: '',
    exportDataArgument: [] as string[], //所有选项
    checkedfieldAll: [] as string[], //全能版
    checkedfieldSimpleBak: [] as string[], //精简版
    checkedfieldSimple: [] as string[] //已选中
})
const selectExportDataArgument = (type) => {
    if (type == 1) {
        exportDataArgumentChecked.checkedfieldSimple = exportDataArgumentChecked.checkedfieldSimpleBak
    } else if (type == 2) {
        exportDataArgumentChecked.checkedfieldSimple = exportDataArgumentChecked.checkedfieldAll
    } else {
        exportDataArgumentChecked.checkedfieldSimple = []
    }
}

const exportDatatab = ref('1')
const exportClick = (type) => {
    data.exportLoading_dc = true
    exportDataArgumentChecked.visible = false
    queryParam.exportfield = exportDataArgumentChecked.checkedfieldSimple
    queryParam.type = type
    if (type == 2) {
        queryParam.companylist = exportDataArgumentChecked.companylist
    }
    let requestParam = {
        url: '/admin/v1/customerExport',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            responseType: 'blob'
        },
        data: queryParam
    }
    baseService(requestParam)
        .then((res) => {
            data.exportLoading_dc = false
            message.success('下载成功')
        })
        .catch((res) => {
            data.exportLoading_dc = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('下载失败')
            }
        })
}

const toggleAdvanced = () => {
    data.advanced = !data.advanced
}
// 修改续费联系人手机号码
const editPhoneChange = (record) => {
    if (!record.new_xftel) {
        message.error('请先填写续费联系人手机号码')
        return
    }

    let promise = mobileRequiredValidator({}, record.new_xftel)
    promise
        .then(() => {
            let data: any = {
                customer_id: record.id,
                xftel: record.new_xftel
            }

            let requestParam = {
                url: '/admin/v1/quickChangeXftel',
                method: 'post',
                data: data
            }
            baseService(requestParam)
                .then((res: any) => {
                    message.success(res.msg)
                    record.isEditXftel = false
                    record.xftel = record.new_xftel
                })
                .catch((res) => {
                    if (res.msg) {
                        message.error(res.msg)
                    } else {
                        message.error('操作失败')
                    }
                })
        })
        .catch((res) => {
            message.error(res)
        })
}

//从天眼查更新数据
const tycupdateData = () => {
    data.tycupdateVisible = false
    //根据查询条件去更新数据
    let requestParam = {
        url: '/admin/v1/tycupdateData',
        method: 'post',
        data: queryParam
    }
    tycupdateDataDo(requestParam)
}
const tycupdateDataDo = (requestParam) => {
    data.exportLoading_gx = true
    baseService(requestParam)
        .then((res: any) => {
            data.exportLoading_gx = false
            message.success(res.msg)
            //等两分钟后再次执行本请求
            if (res.data > 0) {
                setTimeout(() => {
                    message.success('下一轮天眼查查询')
                    tycupdateDataDo(requestParam)
                }, 120000)
            } else {
                message.success('天眼查查询结束')
            }
        })
        .catch((res) => {
            data.exportLoading_gx = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('更新失败')
            }
        })
}
//查询纳税人状态
const taxUpdateData = () => {
    data.taxupdateVisible = false
    //根据查询条件去更新数据
    let requestParam = {
        url: '/admin/v1/taxupdateData',
        method: 'post',
        data: Object.assign({ updatetype: data.updatetype }, queryParam)
    }
    taxUpdateDataDo(requestParam)
}
const taxUpdateDataDo = (requestParam) => {
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            //等两分钟后再次执行本请求
            // if (res.data > 0) {
            //     // setTimeout(() => {
            //     //     message.success('下一轮纳税人状态查询查询')
            //     //     taxUpdateDataDo(requestParam)
            //     // }, 120000)
            // } else {
            //     message.success('纳税人状态查询结束')
            // }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('更新失败')
            }
        })
}

// 复制2
const handleCopyClick2 = (val) => {
    var input = document.createElement('textarea')
    //将input的值设置为需要复制的内容
    input.value = val
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功!')
    //移除input标签
    document.body.removeChild(input)
}
const showWXInform = () => {
    $store.commit('SET_SHOW_WXINFORM', true)
}

//批量分别充值后再付款
const batchData = reactive({
    price: null //价格
})
const openBatchPay = (e) => {
    batchData.price = null
}
const handleBatchPay = () => {
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    //得到本页的id
    let ids: any[] = []
    dataSource.value.forEach((item: any) => {
        ids.push(item.id)
    })
    if (batchData.price && batchData.price < 0) {
        message.error('价格不能小于0')
        return
    }
    let requestParam = {
        url: '/admin/v1/batchPay',
        method: 'post',
        data: { ids: ids, price: batchData.price }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
        .finally(() => {
            setTimeout(hide, 0)
        })
    setTimeout(hide, 10000)
}
//批量操作已办结
const openBatchBanjie = (e) => {
    // console.log(queryParam.platform_id)
}
const handleBatchBanjie = () => {
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })

    //得到本页的id
    let ids: any[] = []
    dataSource.value.forEach((item: any) => {
        ids.push(item.id)
    })
    let requestParam = {
        url: '/admin/v1/batchBanjie',
        method: 'post',
        data: { ids: ids }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
        .finally(() => {
            setTimeout(hide, 0)
        })
    setTimeout(hide, 10000)
}
//下载本页的所有营业执照
const handleBatchLicense = () => {
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })

    //得到本页的id
    let ids: any[] = []
    dataSource.value.forEach((item: any) => {
        ids.push(item.id)
    })
    let requestParam = {
        url: '/admin/v1/batchDownLicense',
        method: 'post',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            responseType: 'blob'
        },
        data: { ids: ids }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
        .finally(() => {
            setTimeout(hide, 0)
        })
    setTimeout(hide, 10000)
}
//一键刻章
const kezhangData = reactive({
    visible: false,
    customerData: {},
    loading: false,
    directPaymentVisible: false,
    directPaymentId: undefined,
})
const oneKeyKezhang = (record) => {
    kezhangData.customerData = record
    kezhangData.visible = true
}
const handleKezhangOk = (type, id) => {
    if (type == 'add') {
        //弹出付款的界面
        handlePay(id)
    }
    kezhangData.visible = false
}
//刻章的付款弹窗
const handlePay = (recordId) => {
    kezhangData.directPaymentVisible = true
    kezhangData.directPaymentId = recordId
}
const handlePayOk = () => {
    kezhangData.directPaymentVisible = false
}
//宽寓免费领章,弹窗领章信息
const freeZhangData = reactive({
    visible: false,
    customerData: {}
})
const freeZhang = (record) => {
    freeZhangData.customerData = record
    freeZhangData.visible = true
}
const freeZhangCancel = () => {
    freeZhangData.visible = false
}

const editdzcode = (record) => {
    record.isEdit = true
}
const saveDzcode = (record) => {
    //保存地址编号
    let dzcode = record.full_address_dzcode
    //判断必须是整数
    if (dzcode && !/^[0-9]*$/.test(dzcode)) {
        message.error('地址编号必须是整数')
        return
    }
    let requestParam = {
        url: '/admin/v1/updateDzcode',
        method: 'post',
        data: { id: record.id, dzcode: dzcode }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            record.isEdit = false
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('保存失败')
            }
        })
}
//上传地址资料
const uploadDzzl = (record) => {
    data.dzzlData = record
    data.dzzlVisible = true
}
//批量硬删除
const batchHarddelete = () => {
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })

    //得到本页的id
    let ids: any[] = []
    dataSource.value.forEach((item: any) => {
        ids.push(item.id)
    })
    let requestParam = {
        url: '/admin/v1/customerDellog/harddestroy',
        method: 'post',
        data: { ids: ids }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
        .finally(() => {
            setTimeout(hide, 0)
        })
    //   setTimeout(hide, 10000)
}
//催地址方上传地址资料
const cuidizhifang = (record) => {
    if (record.is_auto != 1) {
        message.error('请先确定资料没问题再催地址方上传地址资料')
        return
    }
    record.cuidizhifangLoading = true
    let requestParam = {
        url: '/admin/v1/notifyCloudSpeaker',
        method: 'post',
        data: {
            customer_id: record.id,
            step: 1
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            record.cuidizhifangLoading = false
        })
}
//催代理商做单
const cuiSeller = (record) => {
    record.cuiSellerLoading = true
    let requestParam = {
        url: '/admin/v1/notifyCloudSpeaker',
        method: 'post',
        data: {
            customer_id: record.id,
            step: 2
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            record.cuiSellerLoading = false
        })
}
//撤销通知做单
const cancelPushOrder = (record) => {
    let requestParam = {
        url: '/admin/v1/cancelPushOrder',
        method: 'post',
        data: { id: record.id }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
//立即排队
const addQueue = (record) => {
    let requestParam = {
        url: '/admin/v1/freequeue/addQueue',
        method: 'post',
        data: {
            customer_id: record.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
const gototencentword = (record) => {
    let url = 'https://docs.qq.com/doc/DWGtRUXNpUnZqV3BE'
    window.open(url, '_blank')
}
const noticeDoAction = (recordId) => {
    data.noticeDoActionId = recordId
}
const noticeDoActionReal = () => {
    let record = dataSource.value.find((item: any) => item.id == data.noticeDoActionId)
    if (record) {
        onPushOrderMakingClick(record)
    }
}
// 显示活动详情
const activityDetail = reactive({
    activityDetailVisible: false,
    activityDetail: ''
})
const showActivityDetail = (record) => {
    let id = record.activity_info.id
    console.log(id)
    let requestParam = {
        url: `/admin/v1/freeactivity/${id}/edit`,
        method: 'get'
    }
    baseService(requestParam)
        .then((res: any) => {
            activityDetail.activityDetail = res.data.intro
            activityDetail.activityDetailVisible = true
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
const activityDetailCancel = () => {
    activityDetail.activityDetail = ''
    activityDetail.activityDetailVisible = false
}
const idCardNumberClick = (record, status) => {
    record.id_card_number_show = status
    // 复制身份证号
    var input = document.createElement('input')
    //将input的值设置为需要复制的内容
    input.value = record.id_card_number
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功！')
    //移除input标签
    document.body.removeChild(input)
}
const editRemark = (record) => {
    let requestParam = {
        url: '/admin/v1/customer/editRemark',
        method: 'post',
        data: {
            id: record.id,
            remark: record.remark_new
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            record.common_remark = res.data
            record.remarkEdit = false
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
}
//导出待申报数据
let downloadInterval
const downloadsbException = () => {
    data.download_sbException_loading = true
    let requestParam = {
        url: '/admin/v1/downsbExcepiton',
        method: 'post',
        data: queryParam
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.msg == 1) {
                data.download_sbException_loading = false
                message.success(res.data)
            } else if (res.msg == 2) {
                //循环查询
                clearInterval(downloadInterval)
                downloadInterval = setInterval(() => {
                    let requestParam = {
                        url: `/admin/v1/downsbExcepiton`,
                        method: 'POST',
                        data: { rid: res.data }
                    }
                    baseService(requestParam)
                        .then((res2: any) => {
                            if (res2.msg == 3) {
                                //跳转地址下载
                                data.download_sbException_loading = false
                                let requestParam = {
                                    url: '/admin/v1/listZipDown',
                                    method: 'post',
                                    headers: {
                                        'Content-Type': 'application/x-www-form-urlencoded',
                                        responseType: 'blob'
                                    },
                                    data: { list: res2.data, file_name: '待申报地址异常资料', token: token }
                                }
                                baseService(requestParam)
                                    .then((res) => {
                                        message.success('下载成功')
                                    })
                                    .catch((res) => {
                                        if (res.msg) {
                                            message.error(res.msg)
                                        } else {
                                            message.error('下载失败')
                                        }
                                    })
                                clearInterval(downloadInterval)
                            } else if (res2.msg == 5) {
                                data.download_sbException_loading = false
                                message.error('下载失败！')
                                clearInterval(downloadInterval)
                            } else {
                                console.log(res2)
                            }
                        })
                        .catch((res) => { })
                }, 5000)
            }
        })
        .catch((res) => {
            data.download_sbException_loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取待申报异常数据失败')
            }
        })
}
//批量添加备注
const batchRemarkData = reactive({
    remark: null
})
const openBatchRemark = (e) => {
    batchRemarkData.remark = null
}
const handleBatchRemark = () => {
    //得到本页的id
    let ids: any[] = []
    dataSource.value.forEach((item: any) => {
        ids.push(item.id)
    })
    if (!batchRemarkData.remark) {
        message.error('请填写备注')
        return
    }
    const hide = message.loading({
        content: '操作中,请稍等',
        duration: 0,
        class: 'loading-message'
    })
    let requestParam = {
        url: '/admin/v1/batchRemark',
        method: 'post',
        data: { ids: ids, remark: batchRemarkData.remark }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
            loadData()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
        .finally(() => {
            setTimeout(hide, 0)
        })
    setTimeout(hide, 10000)
}
const handleBatchGetIds = () => {
    //得到本页的id
    let ids: any[] = []
    dataSource.value.forEach((item: any) => {
        ids.push(item.id)
    })
    return ids
}
//显示异常记录
const yichangLog = reactive({
    visible: false,
    customer_id: null,
    type: 0,
})
const showYichang = (record, item) => {
    if (item.name == '年报异常') {
        yichangLog.customer_id = record.id
        yichangLog.type = 1
        yichangLog.visible = true
    } else if (item.name == '地址异常') {
        yichangLog.customer_id = record.id
        yichangLog.type = 2
        yichangLog.visible = true
    }
}
const handYichangLogCancel = () => {
    yichangLog.visible = false
}
//限制
const onekeylimit = (record) => {
    let requestParam = {
        url: '/admin/v1/onekeylimit',
        method: 'post',
        data: { data: record }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const copydetailinfo = (record) => {
    const content = `待注册主体信息如下：
公司名称：${record.full_name}
工商预留手机号码：${record.registration_mobile}
经营范围：${record.businessScope}

股东信息及占股比例如下：
${record.shareholder_list.map(item => {
        // 判断合伙人类型
        let partnerType = ''
        if (record.main_type == 4 && (item.type == 2 || item.is_shareholder == 1)) {
            partnerType = item.hehuo_type == 1 ? '（有限合伙人）' : '（普通合伙人）'
        }

        // 截取日期
        const subscribeDate = item.subscribe_endtime?.split(' ')[0] || item.subscribe_endtime

        // 判断职位是否为空
        const positionText = item.position_name ? `担任职位：${item.position_name}` : ''

        return `${item.name}${partnerType} ${item.id_card_number} ${item.address} 资本：${item.investment_money}万 期限：${subscribeDate} ${positionText}`.trim()
    }).join('\r\n\r\n')}
`

    navigator.clipboard.writeText(content)
    message.success('复制成功!')
}
const payLogistics = (record) => {
    data.payLogisticsVisible = true
    data.tableColumnsData = { ...record }
}
const handleChexiao = (record) => {
    let requestParam = {
        url: '/admin/v1/chexiaoZuodan',
        method: 'post',
        data: {
            id: record.id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            message.success(res.msg)
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
        })
}
</script>
<style lang="less" scoped>
.navlist {
    button {
        margin-right: 10px;
    }
}

.tabs {
    position: relative;

    .tabs-right {
        position: absolute;
        right: 0;
        top: 0;
        padding: 12px 0;
        display: flex;
        gap: 32px;
        align-items: center;
    }
}

:deep(.tableRowClass) {
    .ant-table-cell:first-child {
        padding: 0 !important;
    }
}

.table-operator {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 35px !important;
}

.customer-options-popover {
    p {
        padding: 0 16px;
        margin: 0;
        height: 35px;
        line-height: 35px;
        cursor: pointer;
        text-align: center;
        color: #000;
    }

    p:hover {
        color: var(--ant-primary-color);
        background: var(--ant-primary-color-deprecated-bg);
    }
}

.changerole:hover {
    .deng {
        display: inline-block;
    }
}

.changerole {
    .deng {
        display: none;
    }
}

.companyInformation {
    padding: 16px;

    .deng {
        display: none;
    }
}

.companyInformation:hover {
    .deng {
        display: block;
    }
}

.loading-message {
    .ant-message-notice-content {
        border: 1px solid #c8d8cf;
        color: rgb(8, 153, 68);
        background: rgb(233, 252, 241);
    }
}

.shandian {
    margin-top: 5px;
}


.tablewraptr {
    .onekeylimited {
        display: none;
    }
}

.tablewraptr:hover {
    .onekeylimited {
        display: inline-block;
    }
}

.ellipsis-12 {
    display: inline-block;
    max-width: 12em;
    /* 1em约等于1个中文字符宽度 */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
}
</style>
